import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import Select from 'react-select';
import load from "../../../assets/Images/loader.gif";
import * as api from "../../../api_function";
// import BusinessOppotunitySurveyForm from './BusinessOppotunitySurveyForm';
import * as wifiOptions from "../../../options_sets/WifiOptions"
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import { cache } from 'react';
import { components as RSComponents } from 'react-select'


const password = sessionStorage.getItem('password');
const userName = sessionStorage.getItem('userName');

const optionSolutation = [
    { label: "Select Salutation", value: "0" },
    { label: "Mr.", value: "1" },
    { label: "Mrs.", value: "2" },
    { label: "Miss", value: "3" },
];

const optionTurnOver = [
    { label: "Select Option", value: "0" },
    { label: "Diamond (>250Cr)", value: "111260000" },
    { label: "Emerald (100Cr-250Cr)", value: "111260001" },
    { label: "Ruby (10Cr-100Cr)", value: "111260002" },
    { label: "Bronze (1Cr-10Cr)", value: "111260003" }
]

const optionCountry = [{ label: "India", value: "10001" }];

const optionState = [
    { name: "Select State", code: "" },
    { name: "Andhra Pradesh", code: "100009" },
    { name: "Jharkhand", code: "100030" },
    { name: "Bihar", code: "100021" },
    { name: "Delhi", code: "100004" },
    { name: "Gujarat", code: "100015" },
    { name: "Haryana", code: "100008" },
    { name: "Jammu and Kashmir", code: "100011" },
    { name: "Karnataka", code: "100007" },
    { name: "Kerala", code: "100012" },
    { name: "Madhya Pradesh", code: "100014" },
    { name: "Maharashtra", code: "100002" },
    { name: "Odisha", code: "100026" },
    { name: "Other*", code: "100017" },
    { name: "Punjab", code: "100025" },
    { name: "Rajasthan", code: "100010" },
    { name: "Tamil Nadu", code: "100003" },
    { name: "Telangana", code: "100023" },
    { name: "Uttar Pradesh", code: "100006" },
    { name: "Uttarakhand", code: "100016" },
    { name: "West Bengal", code: "100013" },
    { name: "Goa", code: "100028" },
];

const optionCustomerSeg = [
    { label: "Select Customer Segment", value: "0" },
    { label: "SDWAN", value: "111260004" },
    { label: "SMB", value: "111260000" },
    { label: "Media", value: "111260001" },
    { label: "LA", value: "111260002" },
    { label: "SP", value: "111260003" },
];

const firmtype = [
    { value: "0", label: "Select Firm Type" },
    { value: "1", label: "Proprietorship" },
    { value: "2", label: "Partnership" },
    { value: "3", label: "Pvt Ltd" },
    { value: "4", label: "Ltd" },
    { value: "5", label: "Trust" },
    { value: "6", label: "Individual" },
    { value: "7", label: "LLP" },
];

const media = [
    { label: "Fibre", value: "1" },
    { label: "RF", value: "2" },
]

const ExServiceProvider = [
    { label: "Select Service Provider 1", value: "0" },
    { label: "Jio", value: "111260000" },
    { label: "ACT Fibernet", value: "569480014" },
    { label: "N.A", value: "569480012" },
    { label: "Others", value: "569480013" },
    { label: "Airtel", value: "569480000" },
    { label: "Aircel", value: "569480002" },
    { label: "BSNL", value: "569480003" },
    { label: "Hathway", value: "569480004" },
    { label: "MTNL", value: "569480005" },
    { label: "Nextra", value: "569480006" },
    { label: "Reliance Communications", value: "569480007" },
    { label: "Sify", value: "569480008" },
    { label: "Tata Communications", value: "569480009" },
    { label: "Tata DOCOMO", value: "569480010" },
    { label: "Tikona Infinet", value: "569480011" },
    { label: "Vodafone", value: "569480001" },
]

const optionInterestedFirewall = [
    { label: "Select Option", value: "" },
    { label: "Yes", value: "1" },
    { label: "No", value: "2" }
];

const optionInterestedVPN = [
    { label: "Select Option", value: "" },
    { label: "Yes", value: true },
    { label: "No", value: false }
];

const optionInterestedManageWiFi = [
    { label: "Select Option", value: "" },
    { label: "Yes", value: "1" },
    { label: "No", value: "2" }
];



const userTypeOption = [

    { value: "111260000", label: "Base Plan" },
    { value: "111260001", label: "User 2" },
    { value: "111260002", label: "User 3" },
    { value: "111260003", label: "User 4" },
    { value: "111260004", label: "Visitor" },
    { value: "111260005", label: "Event" },
];

const speedPerUserOption = [

    { value: "111260000", label: "Upto 5 Mbps" },
    { value: "111260001", label: "Upto 10 Mbps" },
    { value: "111260002", label: "Upto 15 Mbps" },
    { value: "111260003", label: "Upto 20 Mbps" },
    { value: "111260004", label: "Upto 30 Mbps" },
    { value: "111260005", label: "Upto 40 Mbps" },
    { value: "111260006", label: "Upto 50 Mbps" },
    { value: "111260007", label: "Upto 75 Mbps" },
    { value: "111260008", label: "Upto 100 Mbps" },
];

const planValidityOption = [

    { value: "111260000", label: "Per Day" },
    { value: "111260001", label: "Per Month" },
];

const loginMechanismOption = [
    { value: "111260000", label: "Username & Password" },
    { value: "111260001", label: "Username & Password with Additional Authentication" },
    { value: "111260002", label: "RMN & One-Time Password(OTP)" },
    { value: "111260003", label: "MAC Authentication" },
];


const optionQualify = [
    { label: "Budget Mismatch: SD and OTC", value: "569480019" },
    { label: "Budget Mismatch: Recurring Charge", value: "569480020" },
    { label: "Payment Advance Not Agreed", value: "569480021" },
    { label: "Contract Period Disagreement", value: "569480022" },
    { label: "Contract General Terms Disagreement", value: "569480023" },
    { label: "Customer Unresponsive", value: "569480024" },


];


const BusinessPgOpp = () => {
    const style = {
        control: (base) => ({
            ...base,
            border: 0,
            // Remove box shadow
            boxShadow: "none",
            backgroundColor: "transparent",
            color: "black",
        }),
    };
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            // backgroundColor: "black",
            color: "white",
            // border: "none",
            boxShadow: state.isFocused ? "none" : provided.boxShadow,
            textAlign: "center",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "white",
        }),
        option: (provided, state) => ({
            ...provided,
            // backgroundColor: state.isFocused ? 'blue' : 'black',
            color: "black",
            textAlign: "center",
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: '#f0f0f0',
            borderRadius: '4px',
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: '#333',
        }),
    };

    const [meetingcounter, setmeetingcounter] = useState("");
    const [allPraposalData, setAllPraposalData] = useState([]);
    const [userType, setUserType] = useState("");
    const [speedPerUser, setSpeedPerUser] = useState("");
    const [planValidity, setPlanValidity] = useState("");
    const [loginMechanism, setLoginMechanism] = useState("");

    const [activeForm, setActiveForm] = useState("form1");
    const [loading, setLoading] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState("");
    const [selectedRelatedProduct, setSelectedRelatedProduct] = useState("");
    const [discountFlag, setDiscountFlag] = useState();
    const [getExOtcDiscount, setExOtcDiscount] = useState("NA");
    const [getExRcDiscount, setExRcDiscount] = useState("NA");
    const [productOptions, setProductOptions] = useState([]);
    const [relatedProductOptions, setRelatedProductOptions] = useState([]);
    const [getOTCProd, setOTCProd] = useState([]);
    const [getRCProd, setRCProd] = useState([]);
    const [selectedPriceList, setSelectedPriceList] = useState("");
    const [priceListOptions, setPriceListOptions] = useState([]);
    const [leadid, setleadid] = useState("");
    const [industrydropdetails, setindustrydropdetails] = useState([]);
    const [selectSociety, setSelectSociety] = useState("");
    const [selectedFirmType, setSelectedFirmType] = useState();
    const [selectIndustry, setSelectIndustry] = useState();
    const [selectedCompany, setSelectedCompany] = useState();
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [enableGenerateFeasibilityBtn, setEnableGenerateFeasibilityBtn] = useState(false);
    const [isRedundancyLocked, setIsRedundancyLocked] = useState(false);
    const [selectGroup, setSelectGroup] = useState("");
    const [selectRelationship, setSelectRelationship] = useState({});
    const [loader, setLoader] = useState(false);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [getOtcDiscount, setOtcDiscount] = useState([]);
    const [getRcDiscount, setRcDiscount] = useState([]);
    const [groupOptions, setGroupOptions] = useState([]);
    const [relationshipOptions, setRelationOptions] = useState([]);
    const [selectSolutaton, setSelectSolutaton] = useState(optionSolutation[0]);
    const [statusCode, setStatusCode] = useState("")
    const [status, setStatus] = useState("")
    const [selectCountry, setSelectCountry] = useState("");
    const [selectState, setSelectState] = useState("");
    const [selectCity, setSelectCity] = useState("");
    const [cityType, setCityType] = useState([]);
    const [areaList, setAreaList] = useState([]);
    const [selectArea, setSelectArea] = useState("");
    const [buildingList, setBuildingList] = useState([]);
    const [selectBuilding, setSelectBuilding] = useState("");
    const [selectCustomerSeg, setSelectCustomerSeg] = useState(optionCustomerSeg[0]);
    const [selectTurnOver, setSelectTurnOver] = useState(optionTurnOver[0]);
    const [selectedMedia, setSelectedMedia] = useState(optionTurnOver[0]);
    const [selectExServiceProvider1, setSelectExServiceProvider1] = useState();
    const [selectInterestedFirewall, setSelectInterestedFirewall] = useState('');
    const [selectInterestedVPN, setSelectInteretedVPN] = useState();
    const [selectInterestedManageWiFi, setSelectInterestedManageWiFi] = useState('');
    const [otcAmount, setOtcAmount] = useState("")
    const [rcAmount, setRcAmount] = useState("")
    const [sdAmount, setSdAmount] = useState("")
    const [otcAmountDis, setOtcAmountDis] = useState("")
    const [rcAmountDis, setRcAmountDis] = useState("")
    const [getDoaApprovalData, setDoaApprovalData] = useState([]);
    const [getDoaApprovedFlag, setDoaApprovedFlag] = useState(true);
    const [getFeasibilityApprovedFlag, setFeasibilityApprovedFlag] = useState(true);
    const [getSurveyApprovedFlag, setSurveyApprovedFlag] = useState(true);
    const [getFeasibilityData, setFeasibilityData] = useState([]);
    const [getSurveyTaskData, setSurveyTaskData] = useState([]);
    const [getPreSalesTask, setPreSalesTask] = useState([]);
    const [getSurveyTask, setSurveyTask] = useState([]);
    const [getQuoteDetail, setQuoteDetail] = useState([]);
    const [getCompanyGroupList, setCompanyGroupList] = useState([]);
    const [getUserlicencegridData, setUserlicencegridData] = useState([]);
    const [allQuoteData, setAllQuoteData] = useState([]);
    const [proposalOptionType, setProposalOptionType] = useState("");



    const [showForm, setShowForm] = useState(false)

    const [selectedReasons, setSelectedReasons] = useState([])


    const redirectPriceCalPage = () => {
        if (opportunityData?.Status?.toLowerCase() === "won") {
            Swal.fire({
                icon: "warning",
                html: '<div style="font-size: 14px;">This opportunity is already marked as <b>Won</b> and cannot be edited.</div>',
                confirmButtonText:
                    '<span style="font-size: 14px;color:rgb(148,101,170);">OK</span>',
                confirmButtonColor: "white",
                customClass: {
                    popup: "custom-popup",
                    confirmButton: "custom-confirm-button",
                },
            });
            return; // prevent further execution
        }
        if (opportunityData?.Status?.toLowerCase() === "lost") {
            Swal.fire({
                icon: "warning",
                html: '<div style="font-size: 14px;">This opportunity is already marked as <b>Lost</b> and cannot be edited.</div>',
                confirmButtonText:
                    '<span style="font-size: 14px;color:rgb(148,101,170);">OK</span>',
                confirmButtonColor: "white",
                customClass: {
                    popup: "custom-popup",
                    confirmButton: "custom-confirm-button",
                },
            });
            return; // prevent further execution
        }
        Swal.fire({
            html: '<div style="font-size: 14px;">Unsaved changes will be lost. Do you want to proceed?</div>',
            showCancelButton: true,
            confirmButtonText:
                '<span style="font-size: 14px;color:rgb(148,101,170);">YES</span>',
            cancelButtonText:
                '<span style="font-size: 14px;color:rgb(148,101,170);">NO</span>',
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            customClass: {
                popup: "custom-popup",
                confirmButton: "custom-confirm-button",
                cancelButton: "custom-cancel-button",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                // navigate(`/PriceCalculator?OppId=${OppId}`);
                navigate(`/priceCalculatorPG?OppId=${OppId}`);
            }
        });

    }
    const [totalFloors, setTotalFloors] = useState("");
    const [commonArea, setCommonArea] = useState(null);
    const [elevator, setElevator] = useState(null);
    // For multi-select, we keep the selected options
    const [selectedFloors, setSelectedFloors] = useState([]);
    const pgTypeOptions = [
        { value: "111260000", label: "Men" },
        { value: "111260001", label: "Women" },
        { value: "111260002", label: "Hybrid" },
    ];

    const tenantTypeOptions = [
        { value: "111260000", label: "Professional" },
        { value: "111260001", label: "Student" },
    ];

    const contactDesignationOptions = [
        { value: "111260000", label: "Owner" },
        { value: "111260001", label: "Manager" },
        { value: "111260002", label: "CareTaker" },
        { value: "111260003", label: "Other" },
    ];

    const roleOptions = [
        { value: "111260000", label: "KDM" },
        { value: "111260001", label: "Influencer" },
    ];

    const existingInternetProviderOptions = [
        { value: "111260000", label: "Airtel" },
        { value: "111260001", label: "Jio" },
        { value: "111260002", label: "Tata" },
        { value: "111260003", label: "ACT" },
        { value: "111260004", label: "New Building" },
        { value: "111260005", label: "Others" },
    ];

    const existingInternetOutflowOptions = [
        { value: "111260000", label: "<5000" },
        { value: "111260001", label: "5001 - 10000" },
        { value: "111260002", label: "10001- 15000" },
        { value: "111260003", label: "15001 - 20000" },
        { value: "111260004", label: "20001 - 25000" },
        { value: "111260005", label: ">25000" },
        { value: "111260006", label: "New Building" },
        { value: "111260007", label: "Others" },
    ];

    const urgentTriggersOptions = [
        { value: "111260000", label: "New semester" },
        { value: "111260001", label: "Tenant move-ins" },
        { value: "111260002", label: "Infrastructure Upgrades" },
        { value: "111260003", label: "Expiry of Existing Service Provider" },
        { value: "111260004", label: "New Building" },
    ];

    const spectraRelationshipOptions = [
        { value: "111260000", label: "Existing User" },
        { value: "111260001", label: "Past User" },
        { value: "111260002", label: "New" },
    ];
    const currentInfraOptions = [
        { value: "111260000", label: "Broadband" },
        { value: "111260001", label: "Access Points" },
        { value: "111260002", label: "Others" },
    ];

    // Initial floor coverage state: default is "111260001" (No) for every floor
    const initialFloorCoverage = {
        Basement: "111260001",
        Ground: "111260001",
        First: "111260001",
        Second: "111260001",
        Third: "111260001",
        Fourth: "111260001",
        Fifth: "111260001",
        Sixth: "111260001",
        Seventh: "111260001",
        Eighth: "111260001",
        Ninth: "111260001",
        Tenth: "111260001",
        Other: "111260001",
    };

    // State to hold the coverage flag for each floor
    const [floorCoverage, setFloorCoverage] = useState(initialFloorCoverage);

    // States for floor-specific room/bed details
    const [basementRooms, setBasementRooms] = useState("");
    const [basementBeds, setBasementBeds] = useState("");
    const [groundRooms, setGroundRooms] = useState("");
    const [groundBeds, setGroundBeds] = useState("");
    const [firstRooms, setFirstRooms] = useState("");
    const [firstBeds, setFirstBeds] = useState("");
    const [secondRooms, setSecondRooms] = useState("");
    const [secondBeds, setSecondBeds] = useState("");
    const [thirdRooms, setThirdRooms] = useState("");
    const [thirdBeds, setThirdBeds] = useState("");
    const [fourthRooms, setFourthRooms] = useState("");
    const [fourthBeds, setFourthBeds] = useState("");
    const [fifthRooms, setFifthRooms] = useState("");
    const [fifthBeds, setFifthBeds] = useState("");
    const [sixthRooms, setSixthRooms] = useState("");
    const [sixthBeds, setSixthBeds] = useState("");
    const [seventhRooms, setSeventhRooms] = useState("");
    const [seventhBeds, setSeventhBeds] = useState("");
    const [eighthRooms, setEighthRooms] = useState("");
    const [eighthBeds, setEighthBeds] = useState("");
    const [ninthRooms, setNinthRooms] = useState("");
    const [ninthBeds, setNinthBeds] = useState("");
    const [tenthRooms, setTenthRooms] = useState("");
    const [tenthBeds, setTenthBeds] = useState("");
    const [otherRooms, setOtherRooms] = useState("");
    const [otherBeds, setOtherBeds] = useState("");

    useEffect(() => {
        const fetchGetQuotation = async () => {
            try {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;

                const requestData = {
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "Action": "getQuotation",
                    "OppId": OppId ? OppId : "",
                    "password": sessionStorage.getItem('password'),
                    "userName": sessionStorage.getItem('userName')
                }

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });

                const result = await response.json();

                if (Array.isArray(result?.Response?.Data) && result.Response.Data.length > 0) {
                    const option = result.Response.Data.find(item => item.OptionType) || result.Response.Data[0];
                    setProposalOptionType(option?.OptionType);
                }

                // console.log("API Response getQuotation:", result.Response.Data);
                setAllQuoteData(result?.Response?.Data);




            } catch (error) {
                console.error("Error fetching data:", error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchGetQuotation();
    }, []);

    const handleAddQuote = async () => {
        try {
            setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;

            const requestData = {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "addQuotation",
                "OppId": OppId ? OppId : "",
                "password": sessionStorage.getItem('password'),
                "userName": sessionStorage.getItem('userName')
            }
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            if (result?.Response?.StatusCode == 200) {
                toast.success(result?.Response?.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                window.location.reload()
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        } finally {
            setLoading(false);
        }
    }


    const handleWonQoute = async (quoteId) => {
        try {
            // setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData =
            {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "updateQuote",
                "QuoteID": quoteId,
                "Status": "Won",
                "password": sessionStorage.getItem('password'),
                "userName": sessionStorage.getItem('userName'),
                "CreateRevisedQuote": "Yes"
            }

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            if (result?.Response?.StatusCode == 200) {

                toast.success(result?.Response?.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                window.location.reload()
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        } finally {
            // setLoading(false);
        }
    }

    const handleLostQoute = async (quoteId) => {
        try {
            // setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;

            const requestData = {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "updateQuote",
                "QuoteID": quoteId,
                "Status": "Lost",
                "password": sessionStorage.getItem('password'),
                "userName": sessionStorage.getItem('userName'),
                "CreateRevisedQuote": "Yes"
            }
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            if (result?.Response?.StatusCode == 200) {
                toast.success(result?.Response?.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                window.location.reload()
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        } finally {
            // setLoading(false);
        }
    }
    // Option sets for dropdowns
    const commonAreaOptions = [
        { value: "111260000", label: "Yes" },
        { value: "111260001", label: "No" },
    ];

    const elevatorOptions = [
        { value: "111260000", label: "Yes" },
        { value: "111260001", label: "No" },
    ];

    // Options for the multi-select floors.
    // The value here is the floor identifier; the actual coverage flag is determined dynamically.
    const floorOptions = [
        { value: "Basement", label: "Basement Coverage Required" },
        { value: "Ground", label: "Ground Floor Coverage Required" },
        { value: "First", label: "First Floor Coverage Required" },
        { value: "Second", label: "Second Floor Coverage Required" },
        { value: "Third", label: "Third Floor Coverage Required" },
        { value: "Fourth", label: "Fourth Floor Coverage Required" },
        { value: "Fifth", label: "Fifth Floor Coverage Required" },
        { value: "Sixth", label: "Sixth Floor Coverage Required" },
        { value: "Seventh", label: "Seventh Floor Coverage Required" },
        { value: "Eighth", label: "Eighth Floor Coverage Required" },
        { value: "Ninth", label: "Ninth Floor Coverage Required" },
        { value: "Tenth", label: "Tenth Floor Coverage Required" },
        { value: "Other", label: "Any other Area/Floor Coverage Required" },
    ];

    // Handler for multi-select change: update selectedFloors and floorCoverage mapping.
    const handleFloorSelectChange = (selected) => {
        // Enforce: do not allow selecting more than totalFloors
        const total = parseInt(totalFloors, 10);
        if (!isNaN(total) && selected && selected.length > total) {
            
            toast.warning("Selected Floors must be equal to Total Number of Floors", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
            return; // block update if exceeding total
        }

        setSelectedFloors(selected);
        // Start with all floors defaulting to "No" (111260001)
        const newCoverage = { ...initialFloorCoverage };
        if (selected && selected.length) {
            selected.forEach((item) => {
                // When a floor is selected, update its coverage value to "Yes" (111260000)
                newCoverage[item.value] = "111260000";
            });
        }
        setFloorCoverage(newCoverage);
    };

    const [selectPGType, setSelectPGType] = useState(null);
    const [selectTenantType, setSelectTenantType] = useState(null);
    const [selectContactDesignation, setSelectContactDesignation] = useState(null);

    // Handler for PG Type drop-down
    const handleSelectPGType = (selectedOption) => {
        setSelectPGType(selectedOption);
        setOpportunityData({
            ...opportunityData,
            pgType: selectedOption ? selectedOption.value : "",
        });
    };

    // Handler for Tenant Type drop-down
    const handleSelectTenantType = (selectedOption) => {
        setSelectTenantType(selectedOption);
        setOpportunityData({
            ...opportunityData,
            tenantType: selectedOption ? selectedOption.value : "",
        });
    };

    // Handler for Contact Designation drop-down
    const handleSelectContactDesignation = (selectedOption) => {
        setSelectContactDesignation(selectedOption);
        setOpportunityData({
            ...opportunityData,
            contactDesignation: selectedOption ? selectedOption.value : "",
        });
    };
    const [selectExistingInternetProvider, setSelectExistingInternetProvider] = useState(null);
    const handleSelectExistingInternetProvider = (selectedOption) => {
        setSelectExistingInternetProvider(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            existingInternetProvider: selectedOption ? selectedOption.value : "",
        }));
    };

    // Existing Internet Outflow Per Month
    const [selectExistingInternetOutflow, setSelectExistingInternetOutflow] = useState(null);
    const handleSelectExistingInternetOutflow = (selectedOption) => {
        setSelectExistingInternetOutflow(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            existingInternetOutflow: selectedOption ? selectedOption.value : "",
        }));
    };

    // Current Infra (using placeholder options; update as needed)
    const [selectCurrentInfra, setSelectCurrentInfra] = useState(null);
    const handleSelectCurrentInfra = (selectedOption) => {
        setSelectCurrentInfra(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            currentInfra: selectedOption ? selectedOption.value : "",
        }));
    };

    // Pain Points (multi-select)
    const [selectPainPoints, setSelectPainPoints] = useState([]);
    const handleSelectPainPoints = (selectedOptions) => {
        setSelectPainPoints(selectedOptions);
        setOpportunityData((prev) => ({
            ...prev,
            painPoints: selectedOptions ? selectedOptions.map((option) => option.value) : [],
        }));
    };

    // Urgent Triggers
    const [selectUrgentTriggers, setSelectUrgentTriggers] = useState(null);
    const handleSelectUrgentTriggers = (selectedOption) => {
        setSelectUrgentTriggers(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            urgentTriggers: selectedOption ? selectedOption.value : "",
        }));
    };

    // Spectra Relationship
    const [selectSpectraRelationship, setSelectSpectraRelationship] = useState(null);
    const handleSelectSpectraRelationship = (selectedOption) => {
        setSelectSpectraRelationship(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            spectraRelationship: selectedOption ? selectedOption.value : "",
        }));
    };
    const paymentoptions = [
        { value: "111260000", label: "Advance" },
    ];
    const [selectPayment, setselectPayment] = useState(null);
    const handleselectPayment = (selectedOption) => {
        setselectPayment(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            paymentTerms: selectedOption ? selectedOption.value : "",
        }));
    };
    // Role
    const [selectRole, setSelectRole] = useState(null);
    const handleSelectRole = (selectedOption) => {
        setSelectRole(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            role: selectedOption ? selectedOption.value : "",
        }));
    };

    const handleCompanyChange = (selectedOption) => {
        setSelectedCompany(selectedOption);
    };

    const handleSelectGroup = (selectGroup) => {
        setSelectGroup(selectGroup);
    };

    const handleSelectRelationship = (selectGroup) => {
        setSelectRelationship(selectGroup);
    };

    const handlePriceListChange = (selectOption) => {
        setSelectedPriceList(selectOption);
    };

    const handleSelectFirmType = (selectFirmType) => {
        setSelectedFirmType(selectFirmType);
    };

    const handleIndustryChnage = (selected) => {
        setSelectIndustry(selected);
    };

    const handleSelectSolutation = (selectSolutation) => {
        setSelectSolutaton(selectSolutation);
    };

    const handleSelectCountry = (selectOption) => {
        setSelectCountry(selectOption);
    };

    const handleSelectState = (selectOption) => {
        setSelectState(selectOption);
    };

    const handleSelectCustomerSeg = (selectCustomerSeg) => {
        setSelectCustomerSeg(selectCustomerSeg);
    };

    const handleSelectTurnOver = (selectTurnOver) => {
        setSelectTurnOver(selectTurnOver);
    };

    const handleSelectMedia = (selectMedia) => {
        setSelectedMedia(selectMedia);
    };

    const handleSelectServiceProvider1 = (exServiceProvider) => {
        setSelectExServiceProvider1(exServiceProvider);
    };

    const handleInterestedFirewall = (firewall) => {
        setSelectInterestedFirewall(firewall);
    }

    const handleInterestedVPN = (value) => {
        // console.log(value);

        setSelectInteretedVPN(value);
    }

    const handleInterestedManageWiFi = (value) => {
        setSelectInterestedManageWiFi(value);
    }

    const yyyymmddFormat = (dateStr) => {
        if (!dateStr) return "";
        const parts = dateStr.split("-");
        if (parts.length !== 3) return "";
        if (parts[0].length === 4) {
            return dateStr; // Already in YYYY-MM-DD format
        } else {
            // Convert from DD-MM-YYYY to YYYY-MM-DD
            return `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
    };

    const [minPoNext, setMinPoNext] = useState();
    const [opportunityDataWifi, setOpportunityDataWifi] = useState({});
    const [opportunityData, setOpportunityData] = useState({
        ssId : "",
        userType: "",
        noUserLicences: "",
        speedPerUser: "",
        planValidity: "",
        dataValume: "",
        devicesPerUser: "",
        loginMechanism: "",
        Remarks: "",
        Redunancy: false,
        Block: "",
        Status: "",
        Statuscode: "",
        OppId: "",
        OppStatus: "",
        LeadId: "",
        PriceList: "",
        Topic: "",
        StateId: "",
        CityId: "",
        AreaId: "",
        BuildingId: "",
        SpecificArea: "",
        SpecificBuilding: "",
        Building_BuildingStatus: "",
        NoOfUsers: "",
        NoOfBeds: "",
        IndustryId: "",
        ApprovalRequiredFlag: "",
        Reason: "",
        Area: "",
        Subbusinesssegment: "",
        Businesssegment: "",
        State: "",
        Salutation: "",
        Relationship: "",
        PostalCode: "",
        Mobilephone: "",
        Media: "",
        Lco: null,
        Industry: "",
        Group: "",
        Floor: "",
        TPFeasibilty: "",
        CreateAreaOrBuilding: false,
        Firmtype: "",
        Product: "",
        ProductSegment: "",
        FeasibilityRequired: false,
        Existingprovider: "",
        Emailaddress: "",
        Country: "",
        Companyname: "",
        City: "",
        leadname: "",
        Buildingname: "",
        BuildingNo: "",
        ContactPerson: "",
        CustomerSegment: "",
        LastMileType: "",
        UpTimesla: "",
        Firewall: "",
        CompanySelf: "",
        PoLock: "",
        Price: "",
        OriginatingLead: "",
        FirewallAwc: "",
        PoNext: "",
        Company: "",
        TotalAmount: "",
        VerticalID: "",
        TypeOfOrder: "",
        PocClosureDate: "",
        TurnOver: "",
        SocietyName: "",
        SocietyId: "",
        SocietyStatus: "",
        HousePlotFlatNo: "",
        BlockTowerNumber: "",
        OTCAmount: "",
        SDAmount: "",
        RCAmount: "",
        sdDiscount: "",
        rcDiscount: "",
        otcDiscount: "",
        exOtcDiscount: "",
        exSdDiscount: "",
        commonAreaName: "",
        exRcDiscount: ""
    });
    const modalRef = useRef(null);
    useEffect(() => {
        const fetchGetPraposal = async () => {
            try {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;

                const requestData = {
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "Action": "getProposalList",
                    "OpportunityID": OppId ? OppId : "",
                    "password": sessionStorage.getItem('password'),
                    "userName": sessionStorage.getItem('userName')
                }

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });

                const result = await response.json();

                // console.log("API Response fetchGetPraposal:", result.Response.Data);
                setAllPraposalData(result?.Response?.Data)


            } catch (error) {
                console.error("Error fetching data:", error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchGetPraposal();
    }, []);

    // Function to convert a base64 string to a Blob
    const base64ToBlob = (base64, mime) => {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mime });
    };

    const handleDownload = (data) => {
        // Ensure there is a base64 string available
        const base64String = data.ProposalFileContent;
        if (!base64String) {
            console.error("No base64 data available for download.");
            return;
        }

        // Set the file name and MIME type (adjust if needed)
        const fileName = data.ProposalDocName || "downloaded_document.pdf";
        const mimeType = "application/pdf"; // Change if your document type is different

        // Convert base64 string to a Blob object
        const blob = base64ToBlob(base64String, mimeType);

        // Create a URL for the Blob object
        const blobUrl = URL.createObjectURL(blob);

        // Create a temporary anchor element to trigger the download
        const downloadLink = document.createElement("a");
        downloadLink.href = blobUrl;
        downloadLink.download = fileName;

        // Append the link to the body (required for Firefox)
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Clean up and remove the temporary link
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(blobUrl);
    };
    useEffect(() => {
        const modalElement = modalRef.current;
        if (modalElement) {
            const handleShowModal = (event) => {
                // Button that triggered the modal
                const button = event.relatedTarget;
                // Extract info from data-bs-* attributes
                const recipient = button.getAttribute('data-bs-whatever');
                // Update the modal's content.
                const modalTitle = modalElement.querySelector('.modal-title');
                const modalBodyInput = modalElement.querySelector('.modal-body input');

                if (modalTitle) {
                    modalTitle.textContent = 'New message to ' + recipient;
                }
                if (modalBodyInput) {
                    modalBodyInput.value = recipient;
                }
            };

            modalElement.addEventListener('show.bs.modal', handleShowModal);

            // Cleanup the event listener when the component unmounts
            return () => {
                modalElement.removeEventListener('show.bs.modal', handleShowModal);
            };
        }
    }, []);
    const handleChange = (e) => {
        const { name, value, type } = e.target;

        // console.log(name, value);

        setOpportunityData((prevData) => ({
            ...prevData,
            [name]: type === "number" ? String(value) : value,
        }));

        if (name == "PoLock") {
            let minPoNext = new Date(new Date(value).setFullYear(new Date(value).getFullYear() + 1)).toISOString().split("T")[0]
            setMinPoNext(minPoNext)
            // console.log(PoNext); 
        }
    };



    const discountInput = async (e) => {
        const { name, value, type } = e.target;
        // console.log(name, value, getOTCProd[0], getRCProd[0]);

        // if(!selectedRelatedProduct?.value){
        //   toast.error("Select related product");
        //   return
        // }

        if (name == 'otcDiscount') {

            let req = { oppid: OppId, productid: getOTCProd[0].ProductId, discount: opportunityData.otcDiscount };
            const result = await api.updateOppProduct(req);
            // console.log(result);

        } else if (name == 'rcDiscount') {

            let req = { oppid: OppId, productid: getRCProd[0].ProductId, discount: opportunityData.rcDiscount };
            const result = await api.updateOppProduct(req);
            // console.log(result);

        } else if (name == 'OTCAmount') {
            if (otcAmount > (type === "number" ? String(value) : value)) {
                toast.warning("OTC Amount can't be less than the existing amount.");
                return;
            }
            // console.log(opportunityData.OTCAmount);

            let req = { oppid: OppId, productid: getOTCProd[0].ProductId, priceperunit: opportunityData.OTCAmount, pricing: "Override Price" };
            const result = await api.updateOppProduct(req);
            // console.log(result);

        } else if (name == 'RCAmount') {
            if (rcAmount > (type === "number" ? String(value) : value)) {
                toast.warning("RC Amount can't be less than the existing amount.");
                return;
            }

            let req = { oppid: OppId, productid: getRCProd[0].ProductId, priceperunit: opportunityData.RCAmount, pricing: "Override Price" };
            const result = await api.updateOppProduct(req);
            // console.log(result);

        }
    };


    const manageDocClickBusiness = () => {
        navigate(`/businessCAFmangeNewDoc?OppId=${OppId}`);
        // BusinessSAFmanageFormDOC() ;
    };


    const handleCreateCaf = () => {
        // console.log("leadid", leadid);

        navigate(`/businessCAFmanageForm?OppId=${OppId}&LeadId=${leadid}`)
    };



    const MultiValueRemove = (props) => (
        <RSComponents.MultiValueRemove {...props}>
            <span style={{ color: '#900', fontSize: '16px', lineHeight: '1' }}>×</span>
        </RSComponents.MultiValueRemove>
    )

    const handleChanged = (options) => {
        setSelectedReasons(options || [])
    }


    const handleLost = async () => {

        if (!selectedReasons.length) {
            toast.warning('Please pick at least one reason.')
            return
        }

        const reasonList = selectedReasons.map(o => o.label).join(', ')
        const apiUrl = process.env.REACT_APP_API_URL;
        const payload = {
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            Action: 'opportunityDisqualify',           // ← your new API action
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password'),
            OppID: OppId,                   // fixed key name
            ReasonForDisqualify: reasonList
        }

        try {
            const res = await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            })
            const data = await res.json()

            if (data.StatusCode === '200' || data.Response?.StatusCode === 200) {
                toast.success('Opportunity Lost successfully!', {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                })
                navigate('/businessOpportunityPg')
            } else {
                toast.error(data.Response?.Message || data.Message || 'Failed to disqualify')
            }
        } catch (err) {
            console.error(err)
            toast.error('Network error, please try again.')
        }
    };

    const generateFeasibility = async (opp) => {
        const genfeas = await api.generateFeasibility(opp);
        // console.log(genfeas);
        if (genfeas?.Status == "Success") {
            toast.success(genfeas.Response.Message, {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            })
            setTimeout(() => {
                window.location.reload()
            }, 1500);
        } else {
            toast.error("Feasibility Not Generated.")
        }
    };

    const createSurveyTask = async (opp) => {
        const genfeas = await api.createSurveyTask(opp);
        // console.log(genfeas);
        if (genfeas?.Status == "Success") {
            toast.success(genfeas.Response.Message)
            setTimeout(() => {
                window.location.reload()
            }, 1500);
        } else if ((genfeas.Response.Message).includes("Survey Task already generated")) {
            toast.warning("Survey Task already generated")
        } else {
            toast.error("Survey Task already generated")
        }
    };




    const handleIconClick = (formId) => {
        // if (activeForm !== formId) {
        //   setActiveForm(formId);
        // }

        setActiveForm((prevActiveBox) =>
            prevActiveBox === formId ? null : formId
        );
    };
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const OppId = searchParams.get("OppId");
    const CafId = searchParams.get("CafId");
    const navigate = useNavigate();
    // const redirectLeadPage = () => {
    //   navigate("/businessLead");
    // };

    useEffect(() => {
        const fetchData = async () => {
            const feasibilityData = await api.getFeasibility(OppId);
            const preSalesData = await api.getPreTask(OppId);
            const quoteData = await api.getQuote(OppId);
            const getApprovalData = await api.getApproval(OppId);

            // console.log(getApprovalData.Response.Data);
            // console.log(quoteData?.Response);
            // console.log(preSalesData);

            const allDoaApproved = getApprovalData?.Response?.Data?.every(approval => approval.StatusReason === "Approved" && approval.Status == "Active");
            const allFeasibilityApproved = feasibilityData?.Response?.Data?.every(approval => approval.FeasibilityStatus == "1");

            allDoaApproved !== undefined && setDoaApprovedFlag(allDoaApproved);
            allFeasibilityApproved !== undefined && setFeasibilityApprovedFlag(allFeasibilityApproved);

            // getApprovalData?.Response?.Data?.length > 0 && setDoaApprovalData(getApprovalData?.Response?.Data)
            const activeApproval = getApprovalData?.Response?.Data?.filter(approval => approval.Status == "Active")
            const sortedApproval = activeApproval?.sort((a, b) => parseInt(a.Name.split(" ")[0]) - parseInt(b.Name.split(" ")[0]));
            sortedApproval?.length > 0 && setDoaApprovalData(sortedApproval)

            feasibilityData?.Response?.Data?.length > 0 && setFeasibilityData(feasibilityData?.Response?.Data)
            preSalesData?.Response?.Data?.length > 0 && setPreSalesTask(preSalesData?.Response?.Data)
            setQuoteDetail(quoteData?.Response?.Data)
            // const approvalData = await getApproval();
            // setFeasibilityData(feasibilityData.Response.Data)
            // const generateFeasibilityRes = await generateFeasibility();

            // console.log(feasibilityData?.Response?.Data);

            const getSurveyTaskData = await api.getSurveyTask(OppId);
            const userlicencegrid = await api.getUserlicencegrid(OppId);
            // console.log(userlicencegrid);
            // console.log([getSurveyTaskData?.Response]);
            const allSurveyApproved = getSurveyTaskData?.Response?.Data?.every(approval => approval.Status === "Approved");
            allSurveyApproved !== undefined && setSurveyApprovedFlag(allSurveyApproved);
            [getSurveyTaskData?.Response].length > 0 && setSurveyTaskData([getSurveyTaskData?.Response])


            if (userlicencegrid?.Status == "Success") {
                setUserlicencegridData(userlicencegrid?.Response?.userlicense)
            }
        };

        fetchData();
        // generateFeasibility();
        // createApproval();
        // createQuote();
        // Cleanup function not needed in this case
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestBody = {
                    Action: "getopportunity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    LeadId: "",
                    OppId: OppId ? OppId : "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName'),
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                });

                const responsedata = await response.json();
                const responseData = responsedata?.Response?.Data?.[0];
                // console.log(responseData?.ProductSegment, responseData?.Building_BuildingStatus, responseData?.Redunancy, responseData?.InfraFlag);

                // console.log("getLeads1" ,responsedata1);
                if (responsedata?.Status === "Success" && responseData) {
                    const pgInfo = responseData.PgInfo;
                    setmeetingcounter(pgInfo.MeetingCounter);
                    // console.log("pgInfo.MeetingCounter", pgInfo.MeetingCounter);


                    if ((responseData?.ProductSegment == "BIA" || responseData?.ProductSegment == "Internet Leased Line (ILL)") && responseData?.Building_BuildingStatus == "Non-RFS") {
                        setEnableGenerateFeasibilityBtn(true)
                        setIsRedundancyLocked(false)
                    }
                    if ((responseData?.ProductSegment == "BIA" || responseData?.ProductSegment == "Internet Leased Line (ILL)") && responseData?.Building_BuildingStatus !== "Non-RFS") {
                        setEnableGenerateFeasibilityBtn(false)
                        setIsRedundancyLocked(true)
                    }
                    if ((responseData?.ProductSegment == "Secured Managed Internet" || responseData?.ProductSegment == "Managed Office Solution") && responseData?.Redunancy == true) {
                        setEnableGenerateFeasibilityBtn(true)
                        setIsRedundancyLocked(true)
                    }
                    if (responseData?.ProductSegment == "Managed Wi-Fi Business" && responseData?.InfraFlag !== 'YES' && responseData?.Redunancy == true) {
                        setEnableGenerateFeasibilityBtn(true)
                        setIsRedundancyLocked(false)
                    }
                    if (responseData?.ProductSegment == "Managed Wi-Fi Business" && responseData?.InfraFlag == 'YES' && responseData?.Redunancy == true) {
                        setEnableGenerateFeasibilityBtn(false)
                        setIsRedundancyLocked(true)
                    }


                    // Update the dropdown state variables by mapping the API value to the corresponding option
                    setSelectPGType(pgTypeOptions.find(option => option.value === pgInfo.PGType) || null);
                    setSelectTenantType(tenantTypeOptions.find(option => option.value === pgInfo.TenantType) || null);
                    setSelectContactDesignation(contactDesignationOptions.find(option => option.value === pgInfo.Designation) || null);
                    setSelectRole(roleOptions.find(option => option.value === pgInfo.Role) || null);
                    setSelectExistingInternetProvider(
                        existingInternetProviderOptions.find(option => option.value === pgInfo.ExistingInternetProvider) || null
                    );
                    setSelectExistingInternetOutflow(
                        existingInternetOutflowOptions.find(option => option.value === pgInfo.ExistingInternetOutflowPerMonth) || null
                    );
                    setSelectUrgentTriggers(
                        urgentTriggersOptions.find(option => option.value === pgInfo.UrgentTriggers) || null
                    );
                    setSelectSpectraRelationship(
                        spectraRelationshipOptions.find(option => option.value === pgInfo.SpectraRelationship) || null
                    );
                    const currentInfraOption =
                        currentInfraOptions.find((opt) => opt.value === pgInfo.CurrentInfra) || null;
                    setSelectCurrentInfra(currentInfraOption);

                    // Populate additional PgInfo values for total floors and floor coverage details
                    setTotalFloors(pgInfo.TotalNumberofFloors || "");
                    setCommonArea(commonAreaOptions.find(item => item.value === pgInfo.CommonArea) || null);
                    setElevator(elevatorOptions.find(item => item.value === pgInfo.Elevator) || null);

                    // Update the floor coverage mapping (defaulting to "No" if not provided)
                    setFloorCoverage({
                        Basement: pgInfo.BasementCoverageRequired || "111260001",
                        Ground: pgInfo.GroundFloorCoverageRequired || "111260001",
                        First: pgInfo.FirstFloorCoverageRequired || "111260001",
                        Second: pgInfo.SecondFloorCoverageRequired || "111260001",
                        Third: pgInfo.ThirdFloorCoverageRequired || "111260001",
                        Fourth: pgInfo.FourthFloorCoverageRequired || "111260001",
                        Fifth: pgInfo.FifthFloorCoverageRequired || "111260001",
                        Sixth: pgInfo.SixthFloorCoverageRequired || "111260001",
                        Seventh: pgInfo.SeventhFloorCoverageRequired || "111260001",
                        Eighth: pgInfo.EighthFloorCoverageRequired || "111260001",
                        Ninth: pgInfo.NinthFloorCoverageRequired || "111260001",
                        Tenth: pgInfo.TenthFloorCoverageRequired || "111260001",
                        Other: pgInfo.AnyAreaFloorCoverageRequired || "111260001",
                    });

                    // Update floor-specific room and bed details
                    setBasementRooms(pgInfo.NoOfRoomsinBasement || "");
                    setBasementBeds(pgInfo.NoOfBedsInBasement || "");
                    setGroundRooms(pgInfo.NoOfRoomsinGroundFloor || "");
                    setGroundBeds(pgInfo.NoOfBedsInGroundFloor || "");
                    setFirstRooms(pgInfo.NoOfRoomsinFirstFloor || "");
                    setFirstBeds(pgInfo.NoOfBedsInFirstFloor || "");
                    setSecondRooms(pgInfo.NoOfRoomsinSecondFloor || "");
                    setSecondBeds(pgInfo.NoOfBedsInSecondFloor || "");
                    setThirdRooms(pgInfo.NoOfRoomsinThirdFloor || "");
                    setThirdBeds(pgInfo.NoOfBedsInThirdFloor || "");
                    setFourthRooms(pgInfo.NoOfRoomsinFourthFloor || "");
                    setFourthBeds(pgInfo.NoOfBedsInFourthFloor || "");
                    setFifthRooms(pgInfo.NoOfRoomsinFifthFloor || "");
                    setFifthBeds(pgInfo.NoOfBedsInFifthFloor || "");
                    setSixthRooms(pgInfo.NoOfRoomsinSixthFloor || "");
                    setSixthBeds(pgInfo.NoOfBedsInSixthFloor || "");
                    setSeventhRooms(pgInfo.NoOfRoomsinSeventhFloor || "");
                    setSeventhBeds(pgInfo.NoOfBedsInSeventhFloor || "");
                    setEighthRooms(pgInfo.NoOfRoomsinEighthFloor || "");
                    setEighthBeds(pgInfo.NoOfBedsInEightFloor || ""); // API field is "NoOfBedsInEightFloor"
                    setNinthRooms(pgInfo.NoOfRoomsinNinthFloor || "");
                    setNinthBeds(pgInfo.NoOfBedsInNinthFloor || "");
                    setTenthRooms(pgInfo.NoOfRoomsinTenthFloor || "");
                    setTenthBeds(pgInfo.NoOfBedsInTenthFloor || "");
                    setOtherRooms(pgInfo.NoOfRoomsinAnyotherAreaFloor || "");
                    setOtherBeds(pgInfo.NoOfBedsInAnyAreaFloor || "");

                    const options = await fetchCompanyData("");
                    // console.log(options);
                    let defaultCompanyGroupObj = options?.find((company) => (company.label).includes(responseData.Company));
                    // console.log(defaultCompanyGroupObj);
                    let defaultRelationship = await api.getRelationship(defaultCompanyGroupObj?.value)
                    // console.log(defaultRelationship);

                    setSelectedCompany({
                        value: defaultCompanyGroupObj?.value,
                        label: defaultCompanyGroupObj?.label,
                    });

                    setSelectGroup({
                        value: defaultCompanyGroupObj?.groupId,
                        label: defaultCompanyGroupObj?.group,
                    });

                    // console.log(defaultRelationship);

                    if (defaultRelationship.Response?.Data) {
                        let defaultRelationshipObj = defaultRelationship.Response?.Data?.find((relationship) => (relationship.Relationship_Name).includes(responseData.Relationship));
                        // console.log(defaultRelationshipObj);
                        setSelectRelationship({
                            value: defaultRelationshipObj?.Relationship_ID,
                            label: defaultRelationshipObj?.Relationship_Name
                        });
                    }
                    setCompanyOptions(options);
                    setOtcDiscount(responseData?.OTCDisocuntAmountB)
                    setRcDiscount(responseData?.RCDisocuntAmountB)
                    setOtcAmount(responseData?.OTCAmount)
                    setRcAmount(responseData?.RCAmount)
                    ///////////////////////////////////

                    setOpportunityData({
                        ssId :  pgInfo.SSID || "",
                        Remarks: responseData.Remarks || "",
                        Redunancy: responseData.Redunancy || false,
                        Block: responseData.Block || "",
                        Status: responseData.Status || "",
                        Statuscode: responseData.Statuscode || "",
                        OppId: responseData.OppId || "",
                        OppStatus: responseData.Statuscode || "",
                        LeadId: responseData.LeadId || "",
                        PriceList: responseData.PriceList || "",
                        Topic: responseData.Topic || "",
                        // StateId: responseData.StateId || "",
                        // CityId: responseData.CityId || "",
                        // AreaId: responseData.AreaId || "",
                        BuildingId: responseData.BuildingId || "",
                        SpecificArea: responseData.SpecificArea || "",
                        SpecificBuilding: responseData.SpecificBuilding || "",
                        Building_BuildingStatus: responseData.Building_BuildingStatus || "",
                        NoOfUsers: responseData.NoOfUsers || "",
                        NoOfBeds: responseData.NoOfBeds || "",
                        // IndustryId: responseData.IndustryId || "",
                        ApprovalRequiredFlag: responseData.ApprovalRequiredFlag || "",
                        Reason: responseData.Reason || "",
                        Area: responseData.Area || "",
                        Subbusinesssegment: responseData.Subbusinesssegment || "",
                        Businesssegment: responseData.Businesssegment || "",
                        // State: responseData.State || "",
                        // Salutation: responseData.Salutation || "",
                        Relationship: responseData.Relationship || "",
                        PostalCode: responseData.PostalCode || "",
                        Mobilephone: responseData.Mobilephone || "",
                        Media: responseData.Media || "",
                        Lco: responseData.Lco || null,
                        // Industry: responseData.Industry || "",
                        Group: responseData.Group || "",
                        Floor: responseData.Floor || "",
                        TPFeasibilty: responseData.TPFeasibilty || "",
                        CreateAreaOrBuilding: responseData.CreateAreaOrBuilding || false,
                        Firmtype: responseData.Firmtype || "",
                        Product: responseData.Product || "",
                        ProductSegment: responseData.ProductSegment || "",
                        FeasibilityRequired: responseData.FeasibilityRequired || false,
                        Existingprovider: responseData.Existingprovider || "",
                        Emailaddress: responseData.Emailaddress || "",
                        // Country: responseData.Country || "",
                        Companyname: responseData.leadname || "",
                        // City: responseData.City || "",
                        leadname: responseData.leadname || "",
                        Buildingname: responseData.Buildingname || "",
                        BuildingNo: responseData.BuildingNo || "",
                        ContactPerson: responseData.ContactPerson || "",
                        CustomerSegment: responseData.CustomerSegment || "",
                        LastMileType: responseData.LastMileType || "",
                        UpTimesla: responseData.UpTimesla || "",
                        Firewall: responseData.Firewall || "",
                        // CompanySelf: responseData.CompanySelf || "",
                        PoLock: responseData.PoLock || "",
                        Price: responseData.Price || "",
                        OriginatingLead: responseData.OriginatingLead || "",
                        FirewallAwc: responseData.FirewallAwc || "",
                        PoNext: responseData.PoNext || "",
                        // Company: responseData.Company || "",
                        TotalAmount: responseData.TotalAmount || "",
                        VerticalID: responseData.VerticalID || "",
                        TypeOfOrder: responseData.TypeOfOrder || "",
                        PocClosureDate: responseData.PocClosureDate || "",
                        TurnOver: responseData.TurnOver || "",
                        SocietyName: responseData.SocietyName || "",
                        SocietyId: responseData.SocietyId || "",
                        SocietyStatus: responseData.SocietyStatus || "",
                        HousePlotFlatNo: responseData.HousePlotFlatNo || "",
                        BlockTowerNumber: responseData.BlockTowerNumber || "",
                        OTCAmount: responseData.OTCAmount || "",
                        SDAmount: responseData.SDAmount || "",
                        RCAmount: responseData.RCAmount || "",
                        sdDiscount: responseData.SDDiscountAmount || "",
                        otcDiscount: responseData.OTCDisocuntAmountB || "",
                        rcDiscount: responseData.RCDisocuntAmountB || "",
                        exOtcDiscount: responseData.OTCExtendedAmountB || "",
                        exSdDiscount: responseData.SDExtendedAmount || "",
                        exRcDiscount: responseData.RCExtendedAmountB || "",
                        pgName: pgInfo.PGName || "",
                        pgType: pgInfo.PGType || "",
                        tenantType: pgInfo.TenantType || "",
                        spectraRFS: pgInfo.SpectraRFS || "",
                        contactDesignation: pgInfo.Designation || "",
                        role: pgInfo.Role || "",
                        numberOfRooms: pgInfo.NumberofRooms || "",
                        numberOfBeds: pgInfo.NumberofBeds || "",
                        perBedRent: pgInfo.PerBedRent || "",
                        existingInternetProvider: pgInfo.ExistingInternetProvider || "",
                        existingInternetOutflow: pgInfo.ExistingInternetOutflowPerMonth || "",
                        currentInfra: pgInfo.CurrentInfra || "",
                        googleRatings: pgInfo.GoogleRatings || "",
                        pgInternetRatings: pgInfo.PGInternetRatings || "",
                        urgentTriggers: pgInfo.UrgentTriggers || "",
                        spectraRelationship: pgInfo.SpectraRelationship || "",
                        commonAreaName: pgInfo.CommonName || "",
                        paymentTerms: pgInfo.PaymentTerms,

                        // targetInstallationPeriod:
                        // data.Response[0].otherDetail.TargetInstallationPeriod,
                        painPoints: [
                            pgInfo.PoorCustomerReviews === "1" && "poorCustomerReviews",
                            pgInfo.TenantComplaints === "1" && "tenantComplaints",
                            pgInfo.TenantChurn === "1" && "tenantChurn",
                            pgInfo.PoorCustomerSupportfromexistingvendor === "1" && "poorCustomerSupport",
                            pgInfo.MultipleVendors === "1" && "multipleVendors",
                            pgInfo.NewBuilding === "1" && "newBuilding",
                        ].filter(Boolean),
                    });

                    const paymentoption = paymentoptions.find((opt) => opt.value === pgInfo.PaymentTerms) || null;
                    setselectPayment(paymentoption);
                    const painPointOptions = [];
                    if (pgInfo.PoorCustomerReviews === "1")
                        painPointOptions.push({ value: "poorCustomerReviews", label: "Poor Customer Reviews" });
                    if (pgInfo.TenantComplaints === "1")
                        painPointOptions.push({ value: "tenantComplaints", label: "Tenant Complaints" });
                    if (pgInfo.TenantChurn === "1")
                        painPointOptions.push({ value: "tenantChurn", label: "Tenant Churn" });
                    if (pgInfo.PoorCustomerSupportfromexistingvendor === "1")
                        painPointOptions.push({
                            value: "poorCustomerSupport",
                            label: "Poor Customer Support from existing vendor",
                        });
                    if (pgInfo.MultipleVendors === "1")
                        painPointOptions.push({ value: "multipleVendors", label: "Multiple Vendors" });
                    if (pgInfo.NewBuilding === "1")
                        painPointOptions.push({ value: "newBuilding", label: "New Building" });
                    setSelectPainPoints(painPointOptions);
                    const selected = [];
                    if (pgInfo.BasementCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Basement"));
                    }
                    if (pgInfo.GroundFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Ground"));
                    }
                    if (pgInfo.FirstFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "First"));
                    }
                    if (pgInfo.SecondFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Second"));
                    }
                    if (pgInfo.ThirdFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Third"));
                    }
                    if (pgInfo.FourthFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Fourth"));
                    }
                    if (pgInfo.FifthFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Fifth"));
                    }
                    if (pgInfo.SixthFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Sixth"));
                    }
                    if (pgInfo.SeventhFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Seventh"));
                    }
                    if (pgInfo.EighthFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Eighth"));
                    }
                    if (pgInfo.NinthFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Ninth"));
                    }
                    if (pgInfo.TenthFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Tenth"));
                    }
                    if (pgInfo.AnyAreaFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Other"));
                    }

                    // Update selectedFloors state with the array of selected options
                    setSelectedFloors(selected);
                    setOtcAmountDis(responseData.OTCDiscountAmount);
                    setRcAmountDis(responseData.RCAmount);
                    setOtcAmount(responseData.OTCAmount);
                    setSdAmount(responseData.SDAmount);
                    setleadid(responseData.LeadId);
                    // setSelectedPriceList(responseData.PriceList);
                    // console.log("responseData.Product", responseData.Product)
                    setStatusCode(responseData.Statuscode);
                    setStatus(responseData.Status);
                    setSelectSociety(responseData.SocietyName);

                    setSelectedFirmType(firmtype.find(item => item.value === responseData.Firmtype));
                    setSelectedMedia(media.find(item => item.value === responseData.Media));
                    setSelectExServiceProvider1(ExServiceProvider.find(item => item.value === responseData.Existingprovider));
                    setSelectInterestedFirewall(optionInterestedFirewall.find(item => item.value === responseData.Firewall));
                    setSelectInteretedVPN(optionInterestedVPN.find(item => item.value === responseData.Redunancy));
                    setSelectInterestedManageWiFi(optionInterestedManageWiFi.find(item => item.value === responseData.CompanySelf));

                    // console.log(ExServiceProvider.find(item => item.value === responseData.Existingprovider));

                    let getBuilding = await api.getBuilding({ areaName: responseData.AreaId, areaCode: responseData?.AreaId })


                    let defaultBuilding = getBuilding?.Response?.Data?.find((building) => building.BuildingCode == responseData?.BuildingId)
                    if (defaultBuilding) {
                        // console.log(defaultBuilding);
                        setSelectBuilding({
                            value: defaultBuilding.BuildingCode,
                            label: defaultBuilding.BuildingName
                        })
                    }

                    setSelectedProduct({
                        value: responseData.Product,
                        label: responseData.Product,
                    });

                    setSelectedPriceList(
                        {
                            value: responseData.PriceList,
                            label: responseData.PriceList,
                        }
                    )
                    setSelectCountry({
                        value: responseData.Country,
                        label: responseData.Country,
                    });
                    setSelectState({
                        value: responseData.StateId,
                        label: responseData.State,
                    })
                    setSelectCity({
                        value: responseData.CityId,
                        label: responseData.City,
                    })
                    setSelectArea({
                        value: responseData.AreaId,
                        label: responseData.Area,
                    })
                    setSelectIndustry({
                        value: responseData.IndustryId,
                        label: responseData.Industry,
                    })

                    const filterCustomerSegment = optionCustomerSeg.find(item => item.value === String(responseData.CustomerSegment)).label;


                    setSelectCustomerSeg(
                        {
                            value: responseData.CustomerSegment,
                            label: filterCustomerSegment,
                        });
                    // console.log("responseData.TurnOver",responseData.TurnOver);

                    const filterTurnOver = optionTurnOver?.find(item => item.value === String(responseData?.TurnOver)).label;
                    // console.log("filterTurnOver",filterTurnOver);

                    setSelectTurnOver(
                        {
                            value: responseData.TurnOver,
                            label: filterTurnOver,
                        });
                    const filterSalutationId = optionSolutation.find(
                        (item) => item.value === String(responseData.Salutation)
                    ).label;
                    setSelectSolutaton({
                        value: responseData.Salutation,
                        label: filterSalutationId,
                    });

                    // console.log(companyOptions);

                    // if (responseData?.Company) {
                    //   setSelectedCompany({
                    //     value: responseData.Company,
                    //     label: responseData.Company,
                    //   });
                    // }

                    //////////////
                    // console.log(responseData?.ProductSegment, responseData?.Building_BuildingStatus, responseData?.Redunancy, responseData?.InfraFlag);

                    // if ((segment == "BIA" || segment == "ILL") && BuildingStatus == "Non-RFS") {
                    //   generateFeasibilityBtn(true)
                    //   isRedundancyLocked(false)
                    // }
                    // if ((segment == "BIA" || segment == "ILL") && BuildingStatus !== "Non-RFS") {
                    //   generateFeasibilityBtn(false)
                    //   isRedundancyLocked(true)
                    // }
                    // if ((segment == "MBIA" || segment == "MBB") && RedundancyRequired == "YES") {
                    //   generateFeasibilityBtn(true)
                    //   isRedundancyLocked(false)
                    // }
                    // if (segment == "MS WiFi" && RedundancyRequired == "YES" && InfraFlag !== YES) {
                    //   generateFeasibilityBtn(true)
                    //   isRedundancyLocked(false)
                    // }
                    // if (segment == "MS WiFi" && RedundancyRequired == "YES" && InfraFlag == YES) {
                    //   generateFeasibilityBtn(false)
                    //   isRedundancyLocked(true)
                    // }

                } else {
                    console.error("Error fetching opportunity data:", responseData?.Message);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    // useEffect(() => {
    //   const loadOptions = async () => {
    //     const options = await fetchCompanyData("");
    //     console.log(options);
    //     let defaultCompanyGroupObj = options?.find((company) => (company.label).includes(opportunityData.Company));
    //     console.log(defaultCompanyGroupObj);
    //     let defaultRelationship = await api.getRelationship(defaultCompanyGroupObj?.value)
    //     console.log(defaultRelationship);

    //     setSelectedCompany({
    //       value: defaultCompanyGroupObj?.value,
    //       label: defaultCompanyGroupObj?.label,
    //     });

    //     setSelectGroup({
    //       value: defaultCompanyGroupObj?.groupId,
    //       label: defaultCompanyGroupObj?.group,
    //     });

    //     // console.log(defaultRelationship);

    //     if (defaultRelationship.Response?.length > 0) {
    //       let defaultRelationshipObj = defaultRelationship.Response?.find((relationship) => (relationship.Relationship_ID).includes(opportunityData.Relationship));
    //       console.log(defaultRelationshipObj);
    //       setSelectRelationship({
    //         value: defaultRelationshipObj?.Relationship_ID,
    //         label: defaultRelationshipObj?.Relationship_Name
    //       });
    //     }

    //     setCompanyOptions(options);

    //   };
    //   loadOptions();
    // }, []);

    const handleWon = async () => {
        //  console.log(selectedProduct.value);
        const requiredField = {
            "Topic": opportunityData.Topic ? opportunityData.Topic : "",
            "Block": opportunityData.Block || "",
            // "Building": true,
            "Area": selectArea.value || "",
            "BuildingNo": opportunityData.BuildingNo || "",
            "Buildingname": selectBuilding.value || "",
            "City": selectCity?.value ? selectCity.value : "",
            // "Company Self": selectInterestedManageWiFi?.value || "",
            "Contact Person": opportunityData.ContactPerson ? opportunityData.ContactPerson : "",
            "Country": "10001",
            // "Customer Segment": selectCustomerSeg.value ? selectCustomerSeg.value : "",
            "Email address": opportunityData.Emailaddress ? opportunityData.Emailaddress : "",
            // "Existin gprovider": selectExServiceProvider1.value || "",
            // "Firewall": selectInterestedFirewall?.value || "",
            // "Firmtype": selectedFirmType.value || "",
            "Floor": opportunityData.Floor ? opportunityData.Floor : "",
            "Industry": selectIndustry.value ? selectIndustry.value : "",
            "Media": selectedMedia.value || "",
            "Mobilephone": opportunityData.Mobilephone ? opportunityData.Mobilephone : "",
            // oppId: OppId ? OppId : "",
            // "PO Lock": yyyymmddFormat(opportunityData.PoLock) || "",
            // "PO Next": yyyymmddFormat(opportunityData.PoNext) || "",
            "Postal Code": opportunityData.PostalCode ? opportunityData.PostalCode : "",
            "Price List": selectedPriceList.value ? selectedPriceList.value : "",
            // reason: opportunityData.Reason ? opportunityData.Reason : "",
            // "Redunancy": typeof (selectInterestedVPN?.value) === "boolean" ? selectInterestedVPN?.value : "",  // selectInterestedVPN.value,
            "Salutation": selectSolutaton.value ? selectSolutaton.value : "",
            // specificArea: opportunityData.SpecificArea || "",
            // specificBuilding: opportunityData.SpecificBuilding || "",
            "State": selectState.value ? selectState.value : "",
            // "Turn Over": selectTurnOver.value ? selectTurnOver.value : "",
            // typeOfOrder: "",
            // "UpTime SLA": opportunityData.UpTimesla || "",
        }

        // console.log(requiredField);

        if (!checkRequiredFields(requiredField)) { return }


        try {
            setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
                Action: "wonOpportunity",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                oppid: OppId,
                password: sessionStorage.getItem('password'),
                reason: "",
                siteId: "",
                userName: sessionStorage.getItem('userName'),
            };
            // console.log(requestData);return


            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            const data = await response.json();
            // console.log(data);

            // Check for a successful API response
            if (data.Response.StatusCode == 200) {
                toast.success("Opportunity marked as Won", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                navigate("/businessOpportunityPg")
                setTimeout(() => {
                    window.location.reload();
                }, 1500);

            } else {
                toast.warning(data.Response.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });

            }
        } catch (error) {
            console.error("Error during API call:", error);
        } finally {
            setLoading(false);
        }

    };




    const handleSendToApproval = () => {
        try {
            Swal.fire({
                title: '<div style="font-size: 22px; margin-top:5px;">Action Required</div>',
                text: "Please submit for approval as discount added in OTC or RC amount",
                confirmButtonText:
                    '<span style="font-size: 15px;">Submit for Approval</span>',
                confirmButtonColor: "rgb(148,101,170)",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const { value: formValues } = await Swal.fire({
                        title: `<div style="font-size: 15px;padding: 10px;">Enter Reason for Discount</div>`,
                        // html: `<div style="font-size: 15px;">Reason of Payment DOA</div>`,
                        html: `
                                              <input id="swal-input1" class="swal2-input">  `,
                        focusConfirm: false,
                        preConfirm: () => {
                            // return [document.getElementById("swal-input1").value];
                            const reason = document.getElementById("swal-input1").value.trim();
                            if (!reason) {
                                Swal.showValidationMessage("Reason is required.");
                                return;
                            }
                            return reason;
                        }
                    });
                    if (formValues) {
                        const ApiUrl = process.env.REACT_APP_API_URL;
                        const requestBody = {
                            "Action": "createApproval",
                            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                            "userName": sessionStorage.getItem('userName'),
                            "password": sessionStorage.getItem('password'),
                            "oppid": OppId ? OppId : "",
                            "reason": formValues
                        };
                        const Response = await fetch(ApiUrl, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(requestBody),
                        });
                        const data = await Response.json();
                        // console.log(data)
                        if (data.Status == "Success") {
                            toast.success(data.Response.Message, {
                                position: toast.POSITION.BOTTOM_CENTER,
                                autoClose: 1500,
                            });
                            window.location.reload()
                        }
                    }
                }
            })
        }
        catch (error) {
            console.error("Error during API call:", error);
        }
    }


    const checkRequiredFields = (payload) => {
        for (const key in payload) {
            // console.log(key, ":", payload[key]);

            if (payload[key] === "" || payload[key] === null) {
                // console.log(payload[key]);
                toast.error(`Required field: ${key}`, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                return false; // Stop execution if any field is empty
            }
        }
        return true; // All fields are valid
    };





    const handleUpdateOpportunity = async (event) => {
        try {
            setLoading(true);
            event.preventDefault(); // Prevent default submission
            if (!totalFloors || totalFloors < 1) {
                toast.error("Please enter a valid total number of floors.", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                setLoading(false);
                return;
            }

            if (!commonArea) {
                toast.error("Please select a Common Area.", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                setLoading(false);
                return;
            }

            // If Common Area is required, ensure the Common Area Name is entered
            if (commonArea.value === "111260000" && !opportunityData.commonAreaName) {
                toast.error("Please enter the Common Area Name.", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                setLoading(false);
                return;
            }

            // Validate Elevator is selected
            if (!elevator) {
                toast.error("Please select an Elevator option.", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                setLoading(false);
                return;
            }
            // Validate that at least one floor is selected
            if (!selectedFloors || selectedFloors.length === 0) {
                toast.error("Please select at least one floor.", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                setLoading(false);
                return;
            }

            // Enforce: number of selected floors must equal Total Number of Floors
            const total = parseInt(totalFloors, 10);
            if (!isNaN(total) && selectedFloors.length !== total) {
                toast.error(`Selected Floors must be equal to Total Number of Floors`, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                setLoading(false);
                return;
            }

            // Validate conditional floor fields based on floorCoverage flags
            if (floorCoverage.Basement === "111260000") {
                if (!basementRooms || !basementBeds) {
                    toast.error("Please fill out both the number of rooms and beds for the Basement.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setLoading(false);
                    return;
                }
            }

            if (floorCoverage.Ground === "111260000") {
                if (!groundRooms || !groundBeds) {
                    toast.error("Please fill out both the number of rooms and beds for the Ground Floor.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setLoading(false);
                    return;
                }
            }

            if (floorCoverage.First === "111260000") {
                if (!firstRooms || !firstBeds) {
                    toast.error("Please fill out both the number of rooms and beds for the First Floor.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setLoading(false);
                    return;
                }
            }

            if (floorCoverage.Second === "111260000") {
                if (!secondRooms || !secondBeds) {
                    toast.error("Please fill out both the number of rooms and beds for the Second Floor.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setLoading(false);
                    return;
                }
            }

            if (floorCoverage.Third === "111260000") {
                if (!thirdRooms || !thirdBeds) {
                    toast.error("Please fill out both the number of rooms and beds for the Third Floor.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setLoading(false);
                    return;
                }
            }

            if (floorCoverage.Fourth === "111260000") {
                if (!fourthRooms || !fourthBeds) {
                    toast.error("Please fill out both the number of rooms and beds for the Fourth Floor.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setLoading(false);
                    return;
                }
            }

            if (floorCoverage.Fifth === "111260000") {
                if (!fifthRooms || !fifthBeds) {
                    toast.error("Please fill out both the number of rooms and beds for the Fifth Floor.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setLoading(false);
                    return;
                }
            }

            if (floorCoverage.Sixth === "111260000") {
                if (!sixthRooms || !sixthBeds) {
                    toast.error("Please fill out both the number of rooms and beds for the Sixth Floor.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setLoading(false);
                    return;
                }
            }

            if (floorCoverage.Seventh === "111260000") {
                if (!seventhRooms || !seventhBeds) {
                    toast.error("Please fill out both the number of rooms and beds for the Seventh Floor.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setLoading(false);
                    return;
                }
            }

            if (floorCoverage.Eighth === "111260000") {
                if (!eighthRooms || !eighthBeds) {
                    toast.error("Please fill out both the number of rooms and beds for the Eighth Floor.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setLoading(false);
                    return;
                }
            }

            if (floorCoverage.Ninth === "111260000") {
                if (!ninthRooms || !ninthBeds) {
                    toast.error("Please fill out both the number of rooms and beds for the Ninth Floor.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setLoading(false);
                    return;
                }
            }

            if (floorCoverage.Tenth === "111260000") {
                if (!tenthRooms || !tenthBeds) {
                    toast.error("Please fill out both the number of rooms and beds for the Tenth Floor.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setLoading(false);
                    return;
                }
            }

            if (floorCoverage.Other === "111260000") {
                if (!otherRooms || !otherBeds) {
                    toast.error("Please fill out both the number of rooms and beds for the Other Floor.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    setLoading(false);
                    return;
                }
            }

            // if (opportunityData?.ProductSegment == "Managed Wi-Fi Business-S" || opportunityData?.ProductSegment == "Managed Wi-Fi Business") {
            //     try {
            //         // console.log(opportunitySurveyData);
            //         const updateSurvey = await api.updateopportunityWiFi(opportunitySurveyData)
            //         // console.log(updateSurvey);
            //     } catch (err) { console.error(err); }
            // }

            const requiredField = {
                "Topic": opportunityData.Topic ? opportunityData.Topic : "",
                "Block": opportunityData.Block || "",
                // "Building": true,
                "Area": selectArea.value || "",
                "BuildingNo": opportunityData.BuildingNo || "",
                "Buildingname": selectBuilding.value || "",
                "City": selectCity?.value ? selectCity.value : "",
                // "Company Self": selectInterestedManageWiFi?.value || "",
                "Contact Person": opportunityData.ContactPerson ? opportunityData.ContactPerson : "",
                "Country": "10001",
                "Email address": opportunityData.Emailaddress ? opportunityData.Emailaddress : "",
                "Floor": opportunityData.Floor ? opportunityData.Floor : "",
                "Industry": selectIndustry.value ? selectIndustry.value : "",
                "Mobilephone": opportunityData.Mobilephone ? opportunityData.Mobilephone : "",
               
                "Postal Code": opportunityData.PostalCode ? opportunityData.PostalCode : "",
                "Price List": selectedPriceList.value ? selectedPriceList.value : "",
                "State": selectState.value ? selectState.value : "",
                 "Salutation": selectSolutaton.value ? selectSolutaton.value : "",
               
            }

            // console.log(requiredField);
            if (!checkRequiredFields(requiredField)) { return }

           

            setLoader(true)
            const apiUrl = process.env.REACT_APP_API_URL
            const payload = {
                Action: "updateopportunity",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Remarks: opportunityData.Remarks,
                block: opportunityData.Block || "",
                createAreaOrBuilding: true,
                firewallAwc: yyyymmddFormat(opportunityData?.FirewallAMCExpiryDate) || "",
                pocClosureDate: "",
                area: selectArea.value || "",
                buildingNo: opportunityData.BuildingNo || "",
                buildingname: selectBuilding.value || "",
                city: selectCity.value ? selectCity.value : "",
                companySelf: selectInterestedManageWiFi?.value || "",
                contactPerson: opportunityData.ContactPerson ? opportunityData.ContactPerson : "",
                country: "10001",
                customerSegment: selectCustomerSeg.value ? selectCustomerSeg.value : "111260000",
                emailaddress: opportunityData.Emailaddress ? opportunityData.Emailaddress : "",
                existingprovider: selectExServiceProvider1.value || "",
                firewall: selectInterestedFirewall?.value || "",
                firmtype: selectedFirmType.value || "",
                floor: opportunityData.Floor ? opportunityData.Floor : "",
                industry: selectIndustry.value ? selectIndustry.value : "",
                lco: "",
                media: selectedMedia.value,
                mobilephone: opportunityData.Mobilephone ? opportunityData.Mobilephone : "",
                noOfBeds: "",
                noOfUsers: "",
                oppId: OppId ? OppId : "",
                poLock: yyyymmddFormat(opportunityData.PoLock) || "",
                poNext: yyyymmddFormat(opportunityData.PoNext) || "",
                postalCode: opportunityData.PostalCode ? opportunityData.PostalCode : "",
                priceList: selectedPriceList.value ? selectedPriceList.value : "",
                reason: opportunityData.Reason ? opportunityData.Reason : "",
                redunancy: selectInterestedVPN?.value ? selectInterestedVPN?.value : false,
                salutation: selectSolutaton.value ? selectSolutaton.value : "",
                specificArea: opportunityData.SpecificArea || "",
                specificBuilding: opportunityData.SpecificBuilding || "",
                state: selectState.value ? selectState.value : "",
                topic: opportunityData.Topic ? opportunityData.Topic : "",
                turnOver: selectTurnOver.value ? selectTurnOver.value : "111260003",
                typeOfOrder: "",
                upTimesla: opportunityData.UpTimesla || "",
                societyId: opportunityData.SocietyId || "",
                housePlotFlatNo: opportunityData.HousePlotFlatNo ? opportunityData.HousePlotFlatNo : "",
                blockTowerNumber: opportunityData.BlockTowerNumber ? opportunityData.BlockTowerNumber : "",
                otcAmount: opportunityData.OTCAmount ? opportunityData.OTCAmount : "",
                sdAmount: opportunityData.SDAmount ? opportunityData.SDAmount : "",
            
                password: sessionStorage.getItem('password'),
                userName: sessionStorage.getItem('userName'),
                SDWANOpp: {
                    firewallSetToExpire: "",
                    mPLSContract: "",
                    applicationsHosted: "",
                    currentOperationalCity: "",
                    customerBroadbandServices: "",
                    customerILLservices: "",
                    customerRoutingServices: "No",
                    indicationITSpent: "",
                    itSupport: "",
                    linksManagedLinks: "",
                    mPLSBackbone: "",
                    networkSecurityServices: "",
                    noOfLocation: "",
                    numberOfLinksBroadbandServices: "",
                    numberOfLinksIll: "",
                    redundancyMPLS: "",
                    sdwanRemarks: ""
                },
                PGInfo: {

                    PGType: selectPGType ? selectPGType.value : opportunityData.pgType,
                    TenantType: selectTenantType ? selectTenantType.value : opportunityData.tenantType,
                    Designation: selectContactDesignation ? selectContactDesignation.value : opportunityData.contactDesignation,
                    DesignationOthers: "", // update if you capture a value for this field
                    Role: selectRole ? selectRole.value : opportunityData.role,
                    NumberofRooms: opportunityData.numberOfRooms,
                    NumberofBeds: opportunityData.numberOfBeds,
                    PerBedRent: opportunityData.perBedRent,
                    ExistingInternetProvider: selectExistingInternetProvider
                        ? selectExistingInternetProvider.value
                        : opportunityData.existingInternetProvider,
                    ExistingInternetProviderOther: "", // update if needed
                    ExistingInternetOutflowPerMonth: selectExistingInternetOutflow
                        ? selectExistingInternetOutflow.value
                        : opportunityData.existingInternetOutflow,
                    ExistingInternetOutflowPerMonthOther: "", // update if needed
                    CurrentInfra: selectCurrentInfra ? selectCurrentInfra.value : opportunityData.currentInfra,
                    CurrentInfraOther: "", // update if needed
                    GoogleRatings: opportunityData.googleRatings,
                    PGInternetRatings: opportunityData.pgInternetRatings,
                    PoorCustomerReviews: opportunityData.painPoints?.includes("poorCustomerReviews") ? "1" : "0",
                    TenantComplaints: opportunityData.painPoints?.includes("tenantComplaints") ? "1" : "0",
                    TenantChurn: opportunityData.painPoints?.includes("tenantChurn") ? "1" : "0",
                    PoorCustomerSupportfromexistingvendor: opportunityData.painPoints?.includes("poorCustomerSupport") ? "1" : "0",
                    MultipleVendors: opportunityData.painPoints?.includes("multipleVendors") ? "1" : "0",
                    NewBuilding: opportunityData.painPoints?.includes("newBuilding") ? "1" : "0",
                    UrgentTriggers: selectUrgentTriggers ? selectUrgentTriggers.value : opportunityData.urgentTriggers,
                    SpectraRelationship: selectSpectraRelationship ? selectSpectraRelationship.value : opportunityData.spectraRelationship,
                    TotalNumberofFloors: totalFloors,
                    PaymentTerms: selectPayment?.value || "",
                    SSID : opportunityData?.ssId,
                    CommonArea: commonArea ? commonArea.value : "",
                    CommonName: opportunityData.commonAreaName || "", // if you capture a common area name
                    Elevator: elevator ? elevator.value : "",
                    ElevatorCount: opportunityData.elevatorCount || "", // update if you capture an elevator count
                    // Floor coverage flags

                    BasementCoverageRequired: floorCoverage.Basement,
                    GroundFloorCoverageRequired: floorCoverage.Ground,
                    FirstFloorCoverageRequired: floorCoverage.First,
                    SecondFloorCoverageRequired: floorCoverage.Second,
                    ThirdFloorCoverageRequired: floorCoverage.Third,
                    FourthFloorCoverageRequired: floorCoverage.Fourth,
                    FifthFloorCoverageRequired: floorCoverage.Fifth,
                    SixthFloorCoverageRequired: floorCoverage.Sixth,
                    SeventhFloorCoverageRequired: floorCoverage.Seventh,
                    EighthFloorCoverageRequired: floorCoverage.Eighth,
                    NinthFloorCoverageRequired: floorCoverage.Ninth,
                    TenthFloorCoverageRequired: floorCoverage.Tenth,
                    AnyAreaFloorCoverageRequired: floorCoverage.Other,
                    // Floor-specific room counts
                    NoOfRoomsinBasement: basementRooms,
                    NoOfRoomsinGroundFloor: groundRooms,
                    NoOfRoomsinFirstFloor: firstRooms,
                    NoOfRoomsinSecondFloor: secondRooms,
                    NoOfRoomsinThirdFloor: thirdRooms,
                    NoOfRoomsinFourthFloor: fourthRooms,
                    NoOfRoomsinFifthFloor: fifthRooms,
                    NoOfRoomsinSixthFloor: sixthRooms,
                    NoOfRoomsinSeventhFloor: seventhRooms,
                    NoOfRoomsinEighthFloor: eighthRooms,
                    NoOfRoomsinNinthFloor: ninthRooms,
                    NoOfRoomsinTenthFloor: tenthRooms,
                    NoOfRoomsinAnyotherAreaFloor: otherRooms,
                    // Floor-specific bed counts
                    NoOfBedsInBasement: basementBeds,
                    NoOfBedsInGroundFloor: groundBeds,
                    NoOfBedsInFirstFloor: firstBeds,
                    NoOfBedsInSecondFloor: secondBeds,
                    NoOfBedsInThirdFloor: thirdBeds,
                    NoOfBedsInFourthFloor: fourthBeds,
                    NoOfBedsInFifthFloor: fifthBeds,
                    NoOfBedsInSixthFloor: sixthBeds,
                    NoOfBedsInSeventhFloor: seventhBeds,
                    NoOfBedsInEightFloor: eighthBeds, // API field: "NoOfBedsInEightFloor"
                    NoOfBedsInNinthFloor: ninthBeds,
                    NoOfBedsInTenthFloor: tenthBeds,
                    NoOfBedsInAnyAreaFloor: otherBeds,

                }
            };



            // Send API request
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (opportunityData?.Product && (opportunityData?.otcDiscount || opportunityData?.rcDiscount)) {
                let updateProductreq = { productid: opportunityData.Product, discount: opportunityData.otcDiscount };
                let updateProduct = await api.updateOppProduct(updateProductreq)
            }

            if (result?.Status === "Success") {
                // if (selectedProduct && opportunityData.FeasibilityRequired && getFeasibilityData?.length < 0) {
                //   try {
                //     const createFeasibility = await api.generateFeasibility(OppId);
                //     console.log(createFeasibility);
                //   } catch (err) { console.error(err); }
                // }

                // console.log(opportunityData.otcDiscount, opportunityData.rcDiscount);

                if (opportunityData.otcDiscount || opportunityData.rcDiscount) {
                    try {
                        // console.log("Raise DOA Approval via Api");
                    } catch (err) { console.error(err); }
                }


                toast.success("Opportunity updated successfully!", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                navigate("/businessOpportunityPg");

            } else {
                toast.warning("Failed to update opportunity!", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                return
            }

            // const updateSurvey = await api.updateopportunityWiFi(opportunitySurveyData)
            // console.log(updateSurvey);


        } catch (error) {
            console.error("Error updating opportunity:", error);
            // toast.error("Error updating opportunity.");
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        const fetchData = async () => {
            const getrelationship = await api.getRelationship(selectedCompany?.value)

            // console.log(getrelationship?.Response);

            if (!Array.isArray(getrelationship?.Response)) { return }

            setRelationOptions(getrelationship?.Response?.map((relationship) => (
                {
                    value: relationship.Relationship_ID,
                    label: relationship.Relationship_Name,
                }
            )));



        }

        fetchData()

    }, [selectedCompany]);

    useEffect(() => {
        const getCompanyGrouplist = async () => {
            const getCompany = await api.getCompanyGroup("New Company")
            const oppProduct = await api.getOppProduct({ oppid: OppId });
            // console.log(oppProduct);
            // console.log(oppProduct.Response?.Data);

            let relProductRC = oppProduct?.Response?.Data?.filter((data) => data.ProductId.includes("-RC"))
            let relProductOTC = oppProduct?.Response?.Data?.filter((data) => data.ProductId.includes("-OTC"))

            // console.log(relProductRC, relProductOTC);
            setRCProd(relProductRC)
            setOTCProd(relProductOTC)


            setRelatedProductOptions(oppProduct?.Response?.Data?.map((data) => (
                {
                    value: data.ProductId,
                    label: data.ProductId
                    ,
                }
            )))

            // selectedRelatedProduct()
            // relatedProductOptions()

            setGroupOptions(getCompany?.Response?.Data?.map((data) => (
                {
                    value: data.Group_ID,
                    label: data.Group_Name,
                }
            )))

            setCompanyOptions(getCompany.Response.Data?.map((data) => (
                {
                    value: data.Company_ID,
                    label: data.Company_Name,
                }
            )))
        };

        getCompanyGrouplist()

    }, []);

    useEffect(() => {
        const fetchGetIndustry = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestData = {
                    Action: "getindustrytype",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    areaCode: "",
                    areaName: "",
                    password: sessionStorage.getItem("password"),
                    userName: sessionStorage.getItem("userName"),
                };

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });

                const result = await response.json();
                if (result.Status == "Success") {
                    const industryType = result.Response.map(
                        (option) => ({
                            label: option.IndTypeName,
                            value: option.IndTypeId,
                        })
                    );
                     const updatedtransformedOptions = industryType.filter(item => !['IND_0073_ID','IND_0072_ID','IND_0074_ID'].includes(item.value));
                    setindustrydropdetails(updatedtransformedOptions);
                }
            } catch (error) {
                console.error("Error fetching data:", error.message);
            } finally {

            }
        };

        fetchGetIndustry();
    }, []);



    useEffect(() => {
        const fetchData = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const payload = {
                    Action: "getPricelist",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    buildingname: selectSociety ? selectSociety : "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName')
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });

                const result = await response.json();

                if (result?.Status === "Success" && result?.Response?.Data) {

                    const priceList = result.Response.Data.map(
                        (option) => ({
                            label: option.PriceName,
                            value: option.PriceName,
                        })
                    );
                    setPriceListOptions(priceList);

                } else {
                    console.error("Failed to retrieve price list:", result);
                }
            } catch (error) {
                console.error("Error fetching price list:", error);
            }
        }; fetchData();
    }, [selectSociety]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const payload = {
                    Action: "getProductlist",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    oppid: OppId ? OppId : "",
                    reason: "",
                    siteId: "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName'),
                };

                // Send API request
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });
                const result = await response.json();
                // console.log(result);

                if (result?.Status === "Success") {
                    // const productList = result.Response.Data.map(item => item.ProductId);
                    // console.log("result.Response.Data", result.Response.Data)
                    const productList = result.Response.Data.map(
                        (option) => ({
                            label: option.ProductId,
                            value: option.ProductId,
                        })
                    );
                    setProductOptions(productList);
                }
            } catch (error) {
                console.error("Error fetching product list:", error);
            }
        }; fetchData();
    }, []);

    const relatedProductChange = async (selectedOption) => {
        // console.log(selectedOption);
        // selectedOption.value.includes("-RC")
        setSelectedRelatedProduct(selectedOption);

        if (selectedOption.value.includes("-OTC")) {
            setDiscountFlag("OTC")
            // setOpportunityData((prevData) => ({
            //   ...prevData,
            //   otcDiscount: ""
            // }));
        } else if (selectedOption.value.includes("-RC")) {
            setDiscountFlag("RC")
            // setOpportunityData((prevData) => ({
            //   ...prevData,
            //   rcDiscount: ""
            // }));
        } else {
            setDiscountFlag()
        }
    }


    const handleProductChange = async (selectedOption) => {
        setSelectedProduct(selectedOption);
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestBody = {
                Action: "createOppProduct",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                oppid: OppId ? OppId : "",
                password: sessionStorage.getItem('password'),
                productid: selectedOption.value,
                userName: sessionStorage.getItem('userName'),
            };
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });

            const responsedata = await response.json();

            if (responsedata.Status == "Failure") {
                toast.warning(responsedata.Response.Message.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }

        } catch (error) {
            // Handle fetch error
            console.error("Error fetching data:", error);
        }
    };

    const redirectoppPage = () => {
        Swal.fire({
            html: '<div style="font-size: 15px;">Do you want to go back to the previous screen?</div>',
            showCancelButton: true,
            confirmButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">YES</span>',
            cancelButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            customClass: {
                popup: "custom-popup",
                confirmButton: "custom-confirm-button",
                cancelButton: "custom-cancel-button",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                navigate("/businessOpportunityPg");
            }
        });
    };



    const fetchCompanyData = async () => {
        try {
            setLoader(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestBody = {
                Action: "getCompany",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                companyId: "New Company",
                password: sessionStorage.getItem('password'),
                userName: sessionStorage.getItem('userName'),
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });
            const data = await response.json();
            // console.log("conpany name :", data.Response.Data);
            if (data.Status === "Success" && data.StatusCode === "200") {
                return data.Response.Data.map((company) => ({
                    label: `${company.Company_Name} (${company.Company_ID})`,
                    value: company.Company_ID,
                    group: `${company.Group_Name} (${company.Group_ID})`,
                    groupId: company.Group_ID,
                }));
            } else {
                console.error("Error in API response:", data);
                return [];
            }
        } catch (error) {
            console.error("Error fetching company data:", error);
        } finally {
            setLoader(false);
        }
        return [];
    };

    useEffect(() => {
        const fetchCities = async () => {
            try {
                // City API call
                const cityApiUrl = process.env.REACT_APP_API_URL;
                const cityRequestBody = {
                    Action: "getCity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    password: sessionStorage.getItem('password'),
                    stateCode: selectState.value,
                    userName: sessionStorage.getItem('userName'),
                };
                const cityResponse = await fetch(cityApiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(cityRequestBody),
                });
                const cityData = await cityResponse.json();

                if (cityData.Response && Array.isArray(cityData.Response.Data)) {
                    const filteredCities = cityData.Response.Data.filter(
                        (city) => city.IsOperationalCity === true
                    );
                    setCityType(filteredCities);
                } else {
                    // console.error(
                    //   "City data structure not recognized:",
                    //   cityData.Response
                    // );

                    setCityType([]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        if (selectState) {
            fetchCities();
        }
    }, [selectState]);



    const handleSelectCity = async (selectedOption) => {
        const selectedCityCode = selectedOption ? selectedOption.value : "";
        const selectedCityName = selectedOption ? selectedOption.label : "";
        // console.log("selectedCityCode", selectedOption.value);
        // console.log("selectedCityName", selectedOption.label);
        setSelectCity(selectedOption);
        setSelectArea("");
        // setSelectBuilding("");
        try {
            const areaApiUrl = process.env.REACT_APP_API_URL;
            const areaRequestBody = {
                Action: "getArea",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                cityCode: selectedCityCode,
                cityName: selectedCityName,
                password: sessionStorage.getItem('password'),
                restrictedarea: false,
                stateCode: "",
                userName: sessionStorage.getItem('userName'),
            };
            const areaResponse = await fetch(areaApiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(areaRequestBody),
            });
            const areaData = await areaResponse.json();
            if (areaData.Response && Array.isArray(areaData.Response.Data)) {
                // console.log("area :", areaData.Response.Data);
                setAreaList(areaData.Response.Data);
            }
        } catch (error) {
            console.error("Error fetching area data:", error);
        }
    };

    const handleSelectArea = async (selectedOption) => {
        try {
            // console.log(selectedOption);

            setSelectArea(selectedOption);
            setSelectBuilding("");


            let payload = {
                areaCode: selectedOption.value,
                areaName: selectedOption.label.split(" ")[0]
            }
            let getBuilding = await api.getBuilding(payload);
            // console.log("getBuilding: ", getBuilding);

            if (getBuilding.Response && Array.isArray(getBuilding.Response.Data)) {
                setBuildingList(getBuilding.Response.Data);
            }
        } catch (error) {
            console.error("Error fetching building data:", error);
        }
    };

    // ================ MS-WIFI =======================

    const getWiredLANIntegrationOptions = wifiOptions.getWiredLANIntegrationOptions()
    const getBuildingAndFloorPlanOptions = wifiOptions.getBuildingAndFloorPlanOptions()
    const getNetworkSecurityRequiredOptions = wifiOptions.getNetworkSecurityRequiredOptions();
    const getExistingNetworkSecurityDeviceOptions = wifiOptions.getExistingNetworkSecurityDeviceOptions();
    const getSeparateNetworkForBackOfficeOptions = wifiOptions.getSeparateNetworkForBackOfficeOptions();
    const getBandwidthRequiredOptions = wifiOptions.getBandwidthRequiredOptions();
    const getExistingWiFiCablingByCustomerOptions = wifiOptions.getExistingWiFiCablingByCustomerOptions();
    const getAPIIntegrationRequiredOptions = wifiOptions.getAPIIntegrationRequiredOptions();
    const getPMSVendorForAPIIntegrationOptions = wifiOptions.getPMSVendorForAPIIntegrationOptions();
    const getAnyIOTDevicesToBeConnectedOptions = wifiOptions.getAnyIOTDevicesToBeConnectedOptions();
    const getCountOfExistingInternetLinksOptions = wifiOptions.getCountOfExistingInternetLinksOptions();
    const getTypeOfExistingInternetLinkOptions = wifiOptions.getTypeOfExistingInternetLinkOptions();
    const getUserTypeOptions = wifiOptions.getUserTypeOptions();
    const getSpeedPerUserOptions = wifiOptions.getSpeedPerUserOptions();
    const getLoginMechanismOptions = wifiOptions.getLoginMechanismOptions();
    const getPlanValidityDataVolumeCriteriaOptions = wifiOptions.getPlanValidityDataVolumeCriteriaOptions();
    const getBandwidthTypeOptions = wifiOptions.getBandwidthTypeOptions();
    const getTypeOfWiredLANSetupOptions = wifiOptions.getTypeOfWiredLANSetupOptions();
    const [selectedDropdownObj, setSelectedDropdownObj] = useState({})
    const [opportunitySurveyData, setOpportunitySurveyData] = useState({
        "Action": "updateopportunityWiFi",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "userName": sessionStorage.getItem('userName'),
        "password": sessionStorage.getItem('password')
    })

    const [getCreateGridData, setCreateGridData] = useState({
        "Action": "createUserlicenceGrid",
        "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        "userName": sessionStorage.getItem('userName'),
        "password": sessionStorage.getItem('password'),
    })
    const [oppWifiData, setOppWifiData] = useState({})

    const formInputData = (e) => {
        const { name, value, type } = e.target;
        // console.log(name, value);

        setOpportunitySurveyData((prevData) => ({
            ...prevData,
            [name]: type === "number" ? String(value) : value,
        }));

    };

    const formDropdownInput = (name, value) => {
        // console.log(name, value);
        // console.log("opportunitySurveyData", opportunitySurveyData);

        setOpportunitySurveyData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // const formDropdownInputGrid = (name, value) => {
    //   // const { name, value } = e.target;
    //   console.log(name, value);
    //   // console.log("opportunitySurveyData", getCreateGridData);

    //   setCreateGridData((prevData) => ({
    //     ...prevData,
    //     [name]: value,
    //   }));
    // };


    // const formInputGrid = (e) => {
    //   const { name, value } = e.target;
    //   // console.log(name, value);

    //   setCreateGridData((prevData) => ({
    //     ...prevData,
    //     [name]: value,
    //   }));
    // };

    useEffect(() => {
        async function fetchData() {
            try {
                const oppData = await api.getopportunityWiFi(OppId);
                if (oppData?.Status == "Success") {
                    const opportunityData = oppData?.Response?.oppDetails;
                    // console.log(opportunityData);

                    setOpportunitySurveyData((prevData) => ({
                        ...prevData,
                        "BuildingFloorAttachment": opportunityData?.BuildingFloorAttachment || "",
                        "OppId": OppId || "",
                        "SiteName": opportunityData?.SiteName || "",
                        "CustomerContactName": opportunityData?.CustomerContactName || "",
                        "CustomerContactNumber": opportunityData?.CustomerContactNumber || "",
                        "Customeremailidsitespoc": opportunityData?.Customeremailidsitespoc || "",
                        "ListofBuildings": opportunityData?.ListofBuildings || "",
                        "AreatobeCovered": opportunityData?.AreatobeCovered || "",
                        "BuildingandFloorPlan": opportunityData?.BuildingandFloorPlan || "",
                        "NetworkSecurityrequired": opportunityData?.NetworkSecurityrequired || "",
                        "Anyspecificsecurity": opportunityData?.Anyspecificsecurity || "",
                        "MakeModelofexisting": opportunityData?.MakeModelofexisting || "",
                        "ExistingNetworkSecurityDevice": opportunityData?.ExistingNetworkSecurityDevice || "",
                        "LinkTerminatingFloor": opportunityData?.LinkTerminatingFloor || "",
                        "BandwidthRequired": opportunityData?.BandwidthRequired || "",
                        "Countofexistinginternetlinks": opportunityData?.Countofexistinginternetlinks || "",
                        "ISPofexistinginternetLink1": opportunityData?.ISPofexistinginternetLink1 || "",
                        "TypeofexistinginternetLink1": opportunityData?.TypeofexistinginternetLink1 || "",
                        "BandwidthoFexistinginternetLinkMbps1": opportunityData?.BandwidthoFexistinginternetLinkMbps1 || "",
                        "ISPofexistinginternetLink2": opportunityData?.ISPofexistinginternetLink2 || "",
                        "TypeofexistinginternetLink2": opportunityData?.TypeofexistinginternetLink2 || "",
                        "BandwidthoFexistinginternetLinkMbps2": opportunityData?.BandwidthoFexistinginternetLinkMbps2 || "",
                        "BandwidthType": opportunityData?.BandwidthType || "",
                        "RequiredBandwidthinMbps": opportunityData?.RequiredBandwidthinMbps || "",
                        "WiredLANIntegration": opportunityData?.WiredLANIntegration || "",
                        "NoofwiredLANports": opportunityData?.NoofwiredLANports || "",
                        "TypeofWiredLANSetup": opportunityData?.TypeofWiredLANSetup || "",
                        "MakeModelLANswitches": opportunityData?.MakeModelLANswitches || "",
                        "ExistingWiFiCabling": opportunityData?.ExistingWiFiCabling || "",
                        "APIintegrationrequired": opportunityData?.APIintegrationrequired || "",
                        "PMSVendorforAPIIntegration": opportunityData?.PMSVendorforAPIIntegration || "",
                        "AnyIOTdevicestobeconnected": opportunityData?.AnyIOTdevicestobeconnected || "",
                        "Tentativecountofdevices": opportunityData?.Tentativecountofdevices || "",
                        "SeparatenetworkBackoffice": opportunityData?.SeparatenetworkBackoffice || "",
                        "SpecialRequest": opportunityData?.SpecialRequest || ""
                    }));

                    // setSelectedDropdownObj
                    const BuildingandFloorPlan = getBuildingAndFloorPlanOptions



                } else {
                    throw new Error("getopportunityWiFi API Failure.");
                }
            } catch (err) {
                console.error(err);
            }
        }
        fetchData();
    }, []);


    const handleUserLicenceGrid = async () => {
        // console.log("rtyu");

        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
                "Action": "createUserlicenceGrid",
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "userName": sessionStorage.getItem('userName'),
                "password": sessionStorage.getItem('password'),
                "OppId": OppId ? OppId : "",
                "UserType": userType.value ? userType.value : "",
                "NoofUserLicensesrequired": opportunityData.noUserLicences ? opportunityData.noUserLicences : "",
                "SpeedPerUser": speedPerUser.value ? speedPerUser.value : "",
                "PlanValidityDataVolumeCriteria": planValidity.value ? planValidity.value : "",
                "DataVolumeinGB": opportunityData.dataValume ? opportunityData.dataValume : "",
                "DevicesperUser": opportunityData.devicesPerUser ? opportunityData.devicesPerUser : "",
                "LoginMechanism": loginMechanism.value ? loginMechanism.value : ""
            }
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            const data = await response.json();
            if (data.Response.StatusCode == 200) {
                toast.success(data.Response.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }

        } catch (error) {
            console.error(error);
            toast.error("An error occurred. Please try again later.", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
    }

    const handleUserType = (selectedState) => {
        setUserType(selectedState);
    };

    const handleSpeedPerUser = (selectedState) => {
        setSpeedPerUser(selectedState);
    };

    const handlePlanValidity = (selectedState) => {
        setPlanValidity(selectedState);
    };

    const handleLoginMechanism = (selectedState) => {
        setLoginMechanism(selectedState);
    };

    // ====================== MS-WIFI ======================= 


    return (
        <>
            {/* ***********Header********* */}
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span
                        className=""
                        style={{ cursor: "pointer" }}
                        onClick={redirectoppPage}
                    >
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className=" p-1" >Business Opportunity PG</span>
                    {opportunityData.Status.toLowerCase() == "won" && (
                        <span className=" flr-createCAf" onClick={handleCreateCaf} style={{ fontSize: "10px" }}>
                            Create CAF
                        </span>
                    )}

                    {/* {!opportunityData.FeasibilityRequired && !loading && opportunityData.Status !== "Won" && opportunityData.Building_BuildingStatus == "Non-RFS" && (
            <span className="p-1 flr-createCAf" onClick={() => generateFeasibility(OppId)} style={{ fontSize: "12px" }}>
              Generate Feasibility
            </span>
          )} */}

                    {/* {!opportunityData.FeasibilityRequired && opportunityData.Status !== "Won" && enableGenerateFeasibilityBtn && !loading && (
                        <span className=" flr-createCAf" onClick={() => generateFeasibility(OppId)} style={{ fontSize: "10px", marginRight: "5px" }}>
                            Generate Feasibility
                        </span>
                    )}

                    {(opportunityData?.ProductSegment == "Managed Wi-Fi Business-S" || opportunityData?.ProductSegment == "Managed Wi-Fi Business") && opportunityData.Status !== "Won" && !loading && (
                        <span className=" flr-createCAf" onClick={() => createSurveyTask(OppId)} style={{ fontSize: "10px", marginRight: "5px" }}>
                            Generate Survey Task
                        </span>
                    )} */}

                </div>
            </div>

            {/* ************Header end************ */}

            {loading ? (
                <div className="loader-wrapper">
                    <div className="loader">
                        <img src={load} alt="loading...."></img>
                    </div>
                </div>
            ) : (
                <form>

                    <div className="container-fluid mb-4 form-container">
                        {meetingcounter !== "" && Number(meetingcounter) >= 1 && (
                            <>
                                {(opportunityData.Status !== "Won") && (
                                    <div >
                                        {!showForm ? (
                                            <button
                                                type="button"
                                                className="btn btn-dark w-100 mt-2 btn text-light"
                                                onClick={() => setShowForm(true)}
                                            >
                                                Lost
                                            </button>

                                        ) : (
                                            <>
                                                <Select
                                                    isMulti
                                                    options={optionQualify}
                                                    value={selectedReasons}
                                                    onChange={handleChanged}
                                                    styles={customStyles}
                                                    components={{ MultiValueRemove }}
                                                    className="basic-multi-select disqualify-select"
                                                    classNamePrefix="select"
                                                    placeholder="Select lost Reason(s)..."
                                                    isSearchable={false}
                                                />
                                                <div className="d-flex justify-content-center gap-2 mt-3 mb-2">
                                                    <button
                                                        type="button"
                                                        className="btn text-light bg-dark rounded-pill submit-btn"
                                                        onClick={handleLost}
                                                        disabled={!selectedReasons.length}
                                                    >
                                                        Lost
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn text-light bg-dark rounded-pill submit-btn"
                                                        onClick={() => setShowForm(false)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>

                                            </>
                                        )}
                                    </div>
                                )}
                                {(opportunityData.Status !== "Won") && (
                                    <div>
                                        <button
                                            type='button'
                                            className="btn w-100 mt-2 qualify-btn text-light"
                                            onClick={handleWon}
                                        >
                                            WON
                                        </button>
                                    </div>
                                )}
                                {/* <button
                                    type='button'
                                    className="btn w-100 mt-2 qualify-btn text-light"
                                    onClick={ }
                                >
                                    LOST
                                </button> */}

                            </>
                        )}
                        {(getRcDiscount && getRcDiscount > 0 && getOtcDiscount && getOtcDiscount > 0 && opportunityData?.Statuscode !== "Waiting for Approval" && opportunityData?.Statuscode !== "Approved" && opportunityData?.Statuscode !== "Won") && (
                            <>
                                {!(parseFloat(opportunityData?.OTCAmount) <= parseFloat(getOtcDiscount) ||
                                    parseFloat(opportunityData?.RCAmount) <= parseFloat(getRcDiscount)) && (
                                        <button
                                            type="button"
                                            className="btn w-100 mt-2 qualify-btn text-light"
                                            onClick={handleSendToApproval}
                                        >
                                            Submit for Approval
                                        </button>
                                    )}
                            </>
                        )}

                        {/* **************Opportunity Details toggle******************* */}
                        <div className="contact-toggle mt-3" onClick={() => handleIconClick("form1")}
                        >
                            <span className="toggle-text">Opportunity Details</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>

                        {activeForm === "form1" && (
                            <div className="container shadow  mb-3 bg-body rounded mt-4" id="form1">
                                <fieldset className="contact-form p-2">


                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Mobile Phone"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="Topic"
                                            name="Topic"
                                            value={opportunityData.Topic || ""}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="mobilephone" className='mt-2'>Topic*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Opportunity ID"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="Opportunity"
                                            name="OppId"
                                            value={opportunityData.OppId || ""}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="Opportunity" className='mt-2'>Opportunity ID*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Opportunity ID"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="Opportunity"
                                            name="OppId"
                                            value={opportunityData.OppStatus || ""}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="Opportunity" className='mt-2'>Opportunity Status*</label>
                                    </div>


                                    <div className="">
                                        <label className="select-search-label mt-1">Company*</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="company"
                                            value={selectedCompany}
                                            onChange={handleCompanyChange}
                                            // options={companyOptions}
                                            styles={style}
                                            isSearchable={true}
                                            isLoading={loader}
                                            placeholder="Select Company"
                                            isDisabled={true}
                                        />
                                    </div>

                                    <div className="">
                                        <label className="select-search-label mt-1" htmlFor="floatingSelect"> Group* </label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            id="group"
                                            name="group"
                                            isDisabled={true}
                                            value={selectGroup}
                                            onChange={handleSelectGroup}
                                            // options={groupOptions}
                                            styles={style}
                                            placeholder="Select Group"
                                            isSearchable={true}
                                            isLoading={loader}
                                        />
                                    </div>

                                    <div className="">
                                        <label className="select-search-label mt-1" htmlFor="floatingSelect" > Relationship* </label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            // options={relationshipOptions}
                                            placeholder="Select Relationship"
                                            value={selectRelationship}
                                            onChange={handleSelectRelationship}
                                            styles={style}
                                            isDisabled={true}
                                            isLoading={loader}
                                        />

                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Lead Name"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="leadname"
                                            name="leadname"
                                            value={opportunityData.leadname || ""}
                                            onChange={handleChange}
                                            readOnly
                                            style={{ backgroundColor: 'transparent' }}
                                        />
                                        <label htmlFor="leadname" className='mt-2'>Lead Name*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="Originating"
                                            name="Originating"
                                            value={opportunityData.OriginatingLead || ""}
                                            onChange={handleChange}
                                            readOnly
                                            style={{ backgroundColor: 'transparent' }}
                                        />
                                        <label htmlFor="floatingInput" className='mt-2'>Originating Lead*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="Leadid"
                                            name="Leadid"
                                            value={opportunityData.LeadId || ""}
                                            // onChange={handleChange}
                                            readOnly
                                            style={{ backgroundColor: 'transparent' }}
                                        />
                                        <label htmlFor="floatingInput" className='mt-2'>Lead ID*</label>
                                    </div>



                                </fieldset>
                            </div>
                        )}
                        {/* **************Contact Person Details toggle******************* */}
                        <div className="Lead-Channel-toggle mt-3" onClick={() => handleIconClick("form2")}
                        >
                            <span className="toggle-text">Contact Person Details</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>

                        {activeForm === "form2" && (
                            <div className="container shadow mb-3 bg-body rounded mt-4" id="form2">
                                <fieldset className="Lead-Channel-form p-2">

                                    <div className="">
                                        <label className="select-search-label mt-1">
                                            Salutation*
                                        </label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="Salutation"
                                            placeholder="Select Salutation"
                                            styles={style}
                                            value={selectSolutaton}
                                            isSearchable={false}
                                            onChange={handleSelectSolutation}
                                            options={optionSolutation.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}
                                        />
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Contact Person Name"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="contactPerson"
                                            name="ContactPerson"
                                            value={opportunityData.ContactPerson || ""}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="contactPerson" className='mt-2'>Contact Person Name*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Email"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="contactEmail"
                                            name="Emailaddress"
                                            value={opportunityData.Emailaddress || ""}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="contactEmail" className='mt-2'>Email*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Mobile Number"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="contactMobile"
                                            name="Mobilephone"
                                            value={opportunityData.Mobilephone || ""}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="contactMobile" className='mt-2'>Mobile Number*</label>
                                    </div>


                                    <div className="">
                                        <label className="select-search-label mt-1">Country*</label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="Country"
                                            placeholder="Select Country"
                                            styles={style}
                                            isSearchable={false}
                                            value={{ label: "India", value: "10001" }}
                                            onChange={handleSelectCountry}
                                            options={optionCountry.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}
                                        />
                                    </div>

                                    <div className="">
                                        <label className="select-search-label mt-1">State*</label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="IndustrySeg"
                                            placeholder="Select State"
                                            isSearchable={false}
                                            styles={style}
                                            value={selectState}
                                            onChange={handleSelectState}
                                            options={optionState.map((data) => ({
                                                value: data.code,
                                                label: data.name,
                                            }))}
                                        />
                                    </div>

                                    <div className="">
                                        <label className="select-search-label mt-1">City*</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="City"
                                            placeholder="Select City"
                                            isSearchable
                                            styles={style}
                                            // value={cityType.find(
                                            //   (city) => city.CityCode === selectCity.value
                                            // )}
                                            value={selectCity}
                                            onChange={handleSelectCity}
                                            options={cityType.map((data) => ({
                                                value: data.CityCode,
                                                label: data.CityName,
                                            }))}
                                        />
                                    </div>

                                    <div className="search-area" style={{ position: "relative" }}>
                                        <label className="select-search-label mt-1">Area*</label>
                                        <Select
                                            options={areaList.map((area) => ({
                                                value: area.AreaCode,
                                                label: `${area.AreaName} (${area.AreaCode})`,
                                            }))}
                                            className="form-control form-control-sm p-1 custom-select"
                                            placeholder="Search Area"
                                            isSearchable
                                            styles={style}
                                            value={selectArea}
                                            onChange={handleSelectArea}
                                        />
                                        <i
                                            className="fas fa-search text-secondary"
                                            style={{
                                                position: "absolute",
                                                right: "15px",
                                                top: "63%",
                                                transform: "translateY(-50%)",
                                            }}
                                        ></i>
                                    </div>


                                    <div className="search-area" style={{ position: "relative" }}>
                                        <label className="select-search-label mt-1">Building Name*</label>
                                        <Select
                                            options={buildingList.map((building) => ({
                                                value: building.BuildingCode,
                                                label: `${building.BuildingName} (${building.BuildingCode})`,
                                            }))}
                                            className="form-control form-control-sm p-1 custom-select"
                                            placeholder="Search Area"
                                            isSearchable
                                            styles={style}
                                            value={selectBuilding}
                                            onChange={(selectedOption) =>
                                                setSelectBuilding(selectedOption)
                                            }
                                        />
                                        <i
                                            className="fas fa-search text-secondary"
                                            style={{
                                                position: "absolute",
                                                right: "15px",
                                                top: "63%",
                                                transform: "translateY(-50%)",
                                            }}
                                        ></i>
                                    </div>


                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Building Number"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="buildingNum"
                                            name="BuildingNo"
                                            value={opportunityData.BuildingNo || ""}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="buildingNum" className='mt-2'>Building No./Plot No.*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Block"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="block"
                                            name="Block"
                                            value={opportunityData.Block || ""}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="block" className='mt-2'>Block*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Floor"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="floor"
                                            name="Floor"
                                            value={opportunityData.Floor || ""}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="floor" className='mt-2'>Floor*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Pin Code"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="pin"
                                            name="PostalCode"
                                            value={opportunityData.PostalCode || ""}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="pin" className='mt-2'>Pin*</label>
                                    </div>
                                </fieldset>
                            </div>
                        )}
                        {/* **************Company Details toggle******************* */}
                        <div className="Company-details-toggle mt-3" onClick={() => handleIconClick("form3")}
                        >
                            <span className="toggle-text">Company Details</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>

                        {activeForm === "form3" && (
                            <div className="container shadow mb-3 bg-body rounded mt-4" id="form3">
                                <fieldset className="Company-details-form p-2">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Company Name"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="company"
                                            name="Companyname"
                                            value={opportunityData.Companyname || ""}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="company" className='mt-2'>Company Name*</label>
                                    </div>


                                    <div className="">
                                        <label className="select-search-label">
                                            Firm Type*
                                        </label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="selectCustomerSeg"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectedFirmType}
                                            isSearchable={false}
                                            onChange={handleSelectFirmType}
                                            options={firmtype}
                                        />
                                    </div>


                                    <div className="">
                                        <label className="select-search-label mt-1">
                                            Industry Type*
                                        </label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            placeholder="Select Option"
                                            id="IndustryType"
                                            name="IndustryType"
                                            styles={style}
                                            value={selectIndustry}
                                            // isDisabled={true}
                                            onChange={handleIndustryChnage}
                                            options={industrydropdetails.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}

                                        />
                                    </div>

                                  


                                </fieldset>
                            </div>
                        )}
                        {/* **************PG Info toggle******************* */}
                        <div
                            className="Other-details-toggle mt-3"
                            onClick={() => handleIconClick("form222")}
                        >
                            <span className="toggle-text">PG Info</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>
                       


                        {activeForm === "form222" && (
                            <div
                                className=" container shadow mb-3 bg-body rounded mt-4"
                                id="form222"
                            >
                                {/**********PG Info form******** */}
                                <form className="contact-form pg-info-form p-2">
                                    {/* PG Details Fields */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="pgName"
                                            name="pgName"
                                            value={opportunityData.pgName}
                                            onChange={handleChange}
                                            style={{ background: "transparent" }}
                                        />
                                        <label htmlFor="pgName" className="mt-2">Name of PG</label>
                                    </div>

                                    <div className="select-container mt-2">
                                        <label className="select-search-label">PG Type</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="pgType"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectPGType}
                                            isSearchable={false}
                                            onChange={handleSelectPGType}
                                            options={[
                                                { value: "111260000", label: "Men" },
                                                { value: "111260001", label: "Women" },
                                                { value: "111260002", label: "Hybrid" },
                                            ]}
                                        />
                                    </div>

                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Tenant Type</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="tenantType"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectTenantType}
                                            isSearchable={false}
                                            isDisabled={true}
                                            onChange={handleSelectTenantType}
                                            options={[
                                                { value: "111260000", label: "Professional" },
                                                { value: "111260001", label: "Student" },
                                            ]}
                                        />
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="spectraRFS"
                                            name="spectraRFS"
                                            value={opportunityData.spectraRFS}
                                            onChange={handleChange}
                                            disabled
                                            style={{ background: "transparent" }}
                                        />
                                        <label htmlFor="spectraRFS" className="mt-2">Spectra RFS</label>
                                    </div>

                                     <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="ssId"
                                            name="ssId"
                                            value={opportunityData.ssId}
                                            onChange={handleChange}
                                           
                                            style={{ background: "transparent" }}
                                        />
                                        <label htmlFor="ssId" className="mt-2">SSID</label>
                                    </div>

                                    {/* <div className="select-container mt-2">
                                        <label className="select-search-label">Contact Designation</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="contactDesignation"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectContactDesignation}
                                            isSearchable={false}
                                            onChange={handleSelectContactDesignation}
                                            options={[
                                                { value: "111260000", label: "Owner" },
                                                { value: "111260001", label: "Manager" },
                                                { value: "111260002", label: "CareTaker" },
                                                { value: "111260003", label: "Other" },
                                            ]}
                                        />
                                    </div> */}

                                    <div className="input-box form-floating" style={{ position: "relative", paddingTop: "6px" }}>
                                        <input
                                            type="text"

                                            onKeyDown={(e) => {

                                                const allowedKeys = [

                                                    "Backspace",

                                                    "Delete",

                                                    "ArrowLeft",

                                                    "ArrowRight",

                                                    "Tab",

                                                ];

                                                const isDigit = /\d/.test(e.key);

                                                if (

                                                    (isDigit || allowedKeys.includes(e.key))

                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")

                                                ) {

                                                    return true;

                                                } else {

                                                    e.preventDefault();

                                                }

                                            }}

                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-2"
                                            id="numberOfRooms"
                                            name="numberOfRooms"
                                            value={opportunityData.numberOfRooms}
                                            onChange={handleChange}
                                            readOnly={true}

                                            style={{ background: "transparent" }}
                                        />
                                        <i
                                            className="fa-solid fa-lock text-secondary"
                                            style={{
                                                position: "absolute",
                                                right: "20px",
                                                top: "65%",
                                                transform: "translateY(-50%)",
                                            }}
                                        ></i>
                                        <label htmlFor="numberOfRooms" className="mt-2">Number of Rooms</label>
                                    </div>

                                    <div className="input-box form-floating" style={{ position: "relative", paddingTop: "6px" }}>
                                        <input
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-2"
                                            id="numberOfBeds"
                                            name="numberOfBeds"
                                            value={opportunityData.numberOfBeds}
                                            onChange={handleChange}
                                            readOnly={true}

                                            style={{ background: "transparent" }}
                                            type="text"

                                            onKeyDown={(e) => {

                                                const allowedKeys = [

                                                    "Backspace",

                                                    "Delete",

                                                    "ArrowLeft",

                                                    "ArrowRight",

                                                    "Tab",

                                                ];

                                                const isDigit = /\d/.test(e.key);

                                                if (

                                                    (isDigit || allowedKeys.includes(e.key))

                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")

                                                ) {

                                                    return true;

                                                } else {

                                                    e.preventDefault();

                                                }

                                            }}

                                        />
                                        <i
                                            className="fa-solid fa-lock text-secondary"
                                            style={{
                                                position: "absolute",
                                                right: "20px",
                                                top: "65%",
                                                transform: "translateY(-50%)",
                                            }}
                                        ></i>
                                        <label htmlFor="numberOfBeds" className="mt-2">Number of Beds</label>
                                    </div>

                                    <div className="input-box form-floating" style={{ position: "relative", paddingTop: "6px" }}>
                                        <input
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-2"
                                            id="perBedRent"
                                            name="perBedRent"
                                            value={opportunityData.perBedRent}
                                            onChange={handleChange}
                                            style={{ background: "transparent" }}
                                            readOnly={true}
                                            type="text"

                                            onKeyDown={(e) => {

                                                const allowedKeys = [

                                                    "Backspace",

                                                    "Delete",

                                                    "ArrowLeft",

                                                    "ArrowRight",

                                                    "Tab",

                                                ];

                                                const isDigit = /\d/.test(e.key);

                                                if (

                                                    (isDigit || allowedKeys.includes(e.key))

                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")

                                                ) {

                                                    return true;

                                                } else {

                                                    e.preventDefault();

                                                }

                                            }}

                                        />
                                        <i
                                            className="fa-solid fa-lock text-secondary"
                                            style={{
                                                position: "absolute",
                                                right: "20px",
                                                top: "65%",
                                                transform: "translateY(-50%)",
                                            }}
                                        ></i>
                                        <label htmlFor="perBedRent" className="mt-2">Per Bed Rent</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="googleRatings"
                                            disabled
                                            name="googleRatings"
                                            value={opportunityData.googleRatings}
                                            onChange={handleChange}
                                            style={{ background: "transparent" }}
                                        />
                                        <label htmlFor="googleRatings" className="mt-2">Google Ratings</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="pgInternetRatings"
                                            name="pgInternetRatings"
                                            disabled
                                            value={opportunityData.pgInternetRatings}
                                            onChange={handleChange}
                                            style={{ background: "transparent" }}
                                        />
                                        <label htmlFor="pgInternetRatings" className="mt-2">PG Internet Ratings</label>
                                    </div>

                                    {/* Existing Internet Provider */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Existing Internet Provider</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="existingInternetProvider"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectExistingInternetProvider}
                                            isSearchable={false}
                                            onChange={handleSelectExistingInternetProvider}
                                            options={[
                                                { value: "111260000", label: "Airtel" },
                                                { value: "111260001", label: "Jio" },
                                                { value: "111260002", label: "Tata" },
                                                { value: "111260003", label: "ACT" },
                                                { value: "111260004", label: "New Building" },
                                                { value: "111260005", label: "Others" },
                                            ]}
                                        />
                                    </div>

                                    {/* Existing Internet Outflow Per Month */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Existing Internet Outflow Per Month</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="existingInternetOutflow"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectExistingInternetOutflow}
                                            isSearchable={false}
                                            onChange={handleSelectExistingInternetOutflow}
                                            options={[
                                                { value: "111260000", label: "<5000" },
                                                { value: "111260001", label: "5001 - 10000" },
                                                { value: "111260002", label: "10001- 15000" },
                                                { value: "111260003", label: "15001 - 20000" },
                                                { value: "111260004", label: "20001 - 25000" },
                                                { value: "111260005", label: ">25000" },
                                                { value: "111260006", label: "New Building" },
                                                { value: "111260007", label: "Others" },
                                            ]}
                                        />
                                    </div>

                                    {/* Current Infra */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Current Infra</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="currentInfra"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectCurrentInfra}
                                            isSearchable={false}
                                            onChange={handleSelectCurrentInfra}
                                            options={[
                                                // Placeholder options; adjust these based on your requirements.
                                                { value: "111260000", label: "Broadband" },
                                                { value: "111260001", label: "Access Points" },
                                                { value: "111260002", label: "Others" },
                                            ]}
                                        />
                                    </div>

                                    {/* Pain Points - Multi-Select */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Pain Points</label>
                                        <Select
                                            className="basic-multi-select form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="painPoints"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectPainPoints}
                                            isMulti
                                            onChange={handleSelectPainPoints}
                                            options={[
                                                { value: "poorCustomerReviews", label: "Poor Customer Reviews" },
                                                { value: "tenantComplaints", label: "Tenant Complaints" },
                                                { value: "tenantChurn", label: "Tenant Churn" },
                                                { value: "poorCustomerSupport", label: "Poor Customer Support from existing vendor" },
                                                { value: "multipleVendors", label: "Multiple Vendors" },
                                                { value: "newBuilding", label: "New Building" },
                                            ]}
                                        />
                                    </div>

                                    {/* Urgent Triggers */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Urgent Triggers</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="urgentTriggers"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectUrgentTriggers}
                                            isSearchable={false}
                                            onChange={handleSelectUrgentTriggers}
                                            options={[
                                                { value: "111260000", label: "New semester" },
                                                { value: "111260001", label: "Tenant move-ins" },
                                                { value: "111260002", label: "Infrastructure Upgrades" },
                                                { value: "111260003", label: "Expiry of Existing Service Provider" },
                                                { value: "111260004", label: "New Building" },
                                            ]}
                                        />
                                    </div>

                                    {/* Spectra Relationship */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Spectra Relationship</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="spectraRelationship"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectSpectraRelationship}
                                            isSearchable={false}
                                            onChange={handleSelectSpectraRelationship}
                                            options={[
                                                { value: "111260000", label: "Existing User" },
                                                { value: "111260001", label: "Past User" },
                                                { value: "111260002", label: "New" },
                                            ]}
                                        />
                                    </div>

                                    {/* Role */}
                                    {/* <div className="select-container mt-2">
                                        <label className="select-search-label">Role</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="role"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectRole}
                                            isSearchable={false}
                                            onChange={handleSelectRole}
                                            options={[
                                                { value: "111260000", label: "KDM" },
                                                { value: "111260001", label: "Influencer" },
                                            ]}
                                        />
                                    </div> */}


                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Payment Terms</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="paymentTerms"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectPayment}
                                            isSearchable={false}
                                            onChange={handleselectPayment}
                                            options={[
                                                { value: "111260000", label: "Advance" },
                                            ]}
                                        />
                                    </div>
                                    {/* <div className="input-box form-floating p-0">
                                        <input
                                            type="date"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm mt-1"
                                            id="targetInstallationPeriod"
                                            name="targetInstallationPeriod"
                                            // value={formatDateString(
                                            //   opportunityData.targetInstallationPeriod
                                            // )}
                                            onChange={handleChange}
                                        // min={getCurrentDate()}
                                        />
                                        <label htmlFor="floatingInput" className="mt-2">
                                            Expected Installation Date*
                                        </label>
                                    </div> */}
                                    {/* Total Number of Floors */}
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            id="totalFloors"
                                            name="totalFloors"
                                            styles={style}

                                            value={totalFloors}
                                            onChange={(e) => setTotalFloors(e.target.value)}
                                            className="form-control input-text form-control-sm mt-1"
                                            placeholder=""
                                            style={{ background: "transparent" }}
                                        />
                                        <label htmlFor="totalFloors" className="mt-2">
                                            Total Number of Floors (for Wi‑Fi coverage)*
                                        </label>
                                    </div>

                                    {/* Common Area Dropdown */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Common Area*</label>
                                        <Select
                                            name="commonArea"
                                            styles={style}

                                            value={commonArea}
                                            onChange={setCommonArea}
                                            options={commonAreaOptions}
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            isSearchable={false}
                                        />
                                    </div>
                                    {commonArea && commonArea.value === "111260000" && (
                                        <div className="input-box form-floating mt-2">
                                            <input
                                                type="text"
                                                placeholder=""
                                                className="form-control input-text form-control-sm mt-1"
                                                id="commonAreaName"
                                                name="commonAreaName"
                                                value={opportunityData.commonAreaName || ""}
                                                onChange={handleChange}
                                                style={{ background: "transparent" }}
                                            />
                                            <label htmlFor="commonAreaName" className="mt-2">
                                                Common Area Name*
                                            </label>
                                        </div>
                                    )}

                                    {/* Elevator Dropdown */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Elevator*</label>
                                        <Select
                                            name="elevator"
                                            value={elevator}
                                            styles={style}

                                            onChange={setElevator}
                                            options={elevatorOptions}
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            isSearchable={false}
                                        />
                                    </div>

                                    {/* Multi Select for Floors */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Select the floors*</label>
                                        <Select
                                            name="selectedFloors"
                                            isMulti
                                            styles={style}

                                            value={selectedFloors}
                                            onChange={handleFloorSelectChange}
                                            options={floorOptions}
                                            className="basic-multi-select form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                        />
                                    </div>

                                    {/* Conditional fields for each floor based on floorCoverage flag */}

                                    <>
                                        {/* Basement */}
                                        {floorCoverage.Basement === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="basementRooms"
                                                        name="basementRooms"
                                                        value={basementRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setBasementRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="basementRooms" className="mt-2">
                                                        No. of Rooms in Basement*
                                                    </label>
                                                </div>
                                                <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="basementBeds"
                                                        name="basementBeds"
                                                        value={basementBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setBasementBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="basementBeds" className="mt-2">
                                                        Number of Beds in Basement*
                                                    </label>
                                                </div>
                                            </>
                                        )}

                                        {/* Ground Floor */}
                                        {floorCoverage.Ground === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="groundRooms"
                                                        name="groundRooms"
                                                        value={groundRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setGroundRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="groundRooms" className="mt-2">
                                                        No. of Rooms in Ground Floor*
                                                    </label>
                                                </div>
                                                <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="groundBeds"
                                                        name="groundBeds"
                                                        value={groundBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setGroundBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="groundBeds" className="mt-2">
                                                        Number of Beds in Ground Floor*
                                                    </label>
                                                </div>
                                            </>
                                        )}

                                        {/* First Floor */}
                                        {floorCoverage.First === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="firstRooms"
                                                        name="firstRooms"
                                                        value={firstRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setFirstRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="firstRooms" className="mt-2">
                                                        No. of Rooms in First Floor*
                                                    </label>
                                                </div>
                                                <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="firstBeds"
                                                        name="firstBeds"
                                                        value={firstBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setFirstBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="firstBeds" className="mt-2">
                                                        Number of Beds in First Floor*
                                                    </label>
                                                </div>
                                            </>
                                        )}

                                        {/* Second Floor */}
                                        {floorCoverage.Second === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="secondRooms"
                                                        name="secondRooms"
                                                        value={secondRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setSecondRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="secondRooms" className="mt-2">
                                                        No. of Rooms in Second Floor*
                                                    </label>
                                                </div>
                                                <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="secondBeds"
                                                        name="secondBeds"
                                                        value={secondBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setSecondBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="secondBeds" className="mt-2">
                                                        Number of Beds in Second Floor*
                                                    </label>
                                                </div>
                                            </>
                                        )}

                                        {/* Third Floor */}
                                        {floorCoverage.Third === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="thirdRooms"
                                                        name="thirdRooms"
                                                        value={thirdRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setThirdRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="thirdRooms" className="mt-2">
                                                        No. of Rooms in Third Floor*
                                                    </label>
                                                </div>
                                                <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="thirdBeds"
                                                        name="thirdBeds"
                                                        value={thirdBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setThirdBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="thirdBeds" className="mt-2">
                                                        Number of Beds in Third Floor*
                                                    </label>
                                                </div>
                                            </>
                                        )}

                                        {/* Fourth Floor */}
                                        {floorCoverage.Fourth === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="fourthRooms"
                                                        name="fourthRooms"
                                                        value={fourthRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setFourthRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="fourthRooms" className="mt-2">
                                                        No. of Rooms in Fourth Floor*
                                                    </label>
                                                </div>
                                                <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="fourthBeds"
                                                        name="fourthBeds"
                                                        value={fourthBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setFourthBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="fourthBeds" className="mt-2">
                                                        Number of Beds in Fourth Floor*
                                                    </label>
                                                </div>
                                            </>
                                        )}

                                        {/* Fifth Floor */}
                                        {floorCoverage.Fifth === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="fifthRooms"
                                                        name="fifthRooms"
                                                        value={fifthRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setFifthRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="fifthRooms" className="mt-2">
                                                        No. of Rooms in Fifth Floor*
                                                    </label>
                                                </div>
                                                <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="fifthBeds"
                                                        name="fifthBeds"
                                                        value={fifthBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setFifthBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="fifthBeds" className="mt-2">
                                                        Number of Beds in Fifth Floor*
                                                    </label>
                                                </div>
                                            </>
                                        )}

                                        {/* Sixth Floor */}
                                        {floorCoverage.Sixth === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="sixthRooms"
                                                        name="sixthRooms"
                                                        value={sixthRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setSixthRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="sixthRooms" className="mt-2">
                                                        No. of Rooms in Sixth Floor*
                                                    </label>
                                                </div>
                                                <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="sixthBeds"
                                                        name="sixthBeds"
                                                        value={sixthBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setSixthBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="sixthBeds" className="mt-2">
                                                        Number of Beds in Sixth Floor*
                                                    </label>
                                                </div>
                                            </>
                                        )}

                                        {/* Seventh Floor */}
                                        {floorCoverage.Seventh === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="seventhRooms"
                                                        name="seventhRooms"
                                                        value={seventhRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setSeventhRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="seventhRooms" className="mt-2">
                                                        No. of Rooms in Seventh Floor*
                                                    </label>
                                                </div>
                                                <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="seventhBeds"
                                                        name="seventhBeds"
                                                        value={seventhBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setSeventhBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="seventhBeds" className="mt-2">
                                                        Number of Beds in Seventh Floor*
                                                    </label>
                                                </div>
                                            </>
                                        )}

                                        {/* Eighth Floor */}
                                        {floorCoverage.Eighth === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="eighthRooms"
                                                        name="eighthRooms"
                                                        value={eighthRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setEighthRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="eighthRooms" className="mt-2">
                                                        No. of Rooms in Eighth Floor*
                                                    </label>
                                                </div>
                                                <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="eighthBeds"
                                                        name="eighthBeds"
                                                        value={eighthBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setEighthBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="eighthBeds" className="mt-2">
                                                        Number of Beds in Eighth Floor*
                                                    </label>
                                                </div>
                                            </>
                                        )}

                                        {/* Ninth Floor */}
                                        {floorCoverage.Ninth === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="ninthRooms"
                                                        name="ninthRooms"
                                                        value={ninthRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setNinthRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="ninthRooms" className="mt-2">
                                                        No. of Rooms in Ninth Floor*
                                                    </label>
                                                </div>
                                                <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="ninthBeds"
                                                        name="ninthBeds"
                                                        value={ninthBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setNinthBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="ninthBeds" className="mt-2">
                                                        Number of Beds in Ninth Floor*
                                                    </label>
                                                </div>
                                            </>
                                        )}

                                        {/* Tenth Floor */}
                                        {floorCoverage.Tenth === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="tenthRooms"
                                                        name="tenthRooms"
                                                        value={tenthRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setTenthRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="tenthRooms" className="mt-2">
                                                        No. of Rooms in Tenth Floor*
                                                    </label>
                                                </div>
                                                <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="tenthBeds"
                                                        name="tenthBeds"
                                                        value={tenthBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setTenthBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="tenthBeds" className="mt-2">
                                                        Number of Beds in Tenth Floor*
                                                    </label>
                                                </div>
                                            </>
                                        )}

                                        {/* Other Floor */}
                                        {floorCoverage.Other === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="otherRooms"
                                                        name="otherRooms"
                                                        value={otherRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setOtherRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="otherRooms" className="mt-2">
                                                        No. of Rooms in Other Floor*
                                                    </label>
                                                </div>
                                                <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="otherBeds"
                                                        name="otherBeds"
                                                        value={otherBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setOtherBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        style={{ background: "transparent" }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="otherBeds" className="mt-2">
                                                        Number of Beds in Other Floor*
                                                    </label>
                                                </div>
                                            </>
                                        )}
                                    </>


                                </form>
                            </div>
                        )}

                       

                        <div className="Remarks-toggle mt-3" onClick={redirectPriceCalPage}>
                            <span className="toggle-text">Plan Selector</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>
                        <div className="Remarks-toggle mt-3" onClick={() => handleIconClick("form13")}
                        >
                            <span className="toggle-text">Proposal Details</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>


                        {activeForm === "form13" && (
                            <div className="container shadow mb-3 bg-body rounded mt-4" id="form13">
                                <fieldset className="Remarks-form p-2">
                                    <div className="Other-details-toggle mt-3">

                                        <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                                            {allPraposalData && allPraposalData?.length > 0 ? (
                                                allPraposalData.map((data, index) => (
                                                    <div className="col" key={index}>
                                                        <div className="card mb-3">
                                                            <div className="m-3 card-data" style={{ display: "inline-flex" }} >
                                                                <div>
                                                                    {/* <p className="caf-card-text">Opportunity Id : {data.OpportunityID}</p>
                                  <p className="caf-card-text" style={{ textWrap: "nowrap" }}> Document Name : {data.ProposalDocName}</p> */}
                                                                    <p className="caf-card-text">Created On : {data.ProposalCreatedOn}</p>

                                                                </div>
                                                            </div>
                                                            <div className="d-flex justify-content-center gap-2 p-2">
                                                                <button type="button" className="btn qualify-btn text-light w-50" onClick={() => handleDownload(data)}>
                                                                    Download
                                                                </button>

                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="col-12 text-center">
                                                    <p>No data available.</p>
                                                </div>
                                            )}
                                        </div>



                                    </div>
                                </fieldset>
                            </div>
                        )}


                        {opportunityData.Status.toLowerCase() == "won" && (
                            <div
                                className="Other-details-toggle mt-3"
                                onClick={() => navigate(`/purchaseOrder?OppId=${OppId}`)}
                            >
                                <span className="toggle-text">PG PO Document</span>
                                <span className=" float-end">
                                    <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                                </span>
                            </div>
                        )}


                        <div className="Remarks-toggle mt-3" onClick={() => handleIconClick("form12")}
                        >
                            <span className="toggle-text">Quote Details</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>


                        {activeForm === "form12" && (
                            <div className="container shadow mb-3 bg-body rounded mt-4" id="form12">
                                <fieldset className="Remarks-form p-2">
                                    <div className="Other-details-toggle mt-3">
                                        {/* <div className='mb-4'>
                                            <button
                                                type='button'
                                                className="btn w-100 mt-2 qualify-btn text-light"
                                                onClick={handleAddQuote}
                                            >
                                                Add Quote
                                            </button>
                                        </div> */}

                                        <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                                            {allQuoteData && allQuoteData?.length > 0 ? (
                                                allQuoteData.map((data, index) => (
                                                    <div className="col" key={index}>
                                                        <div className="card mb-3">
                                                            <div className="m-3 card-data" style={{ display: "inline-flex" }} >
                                                                <div>
                                                                    <p className="caf-card-text">Quote Id : {data.Quoteid}</p>
                                                                    <p className="caf-card-text">Total Amount : {data.TotalAmount}</p>
                                                                    <p className="caf-card-text" style={{ lineHeight: "20px" }}>Opportunity Name : {data.OpportunityName}</p>
                                                                    <p className="caf-card-text">Status : {data.Status}</p>
                                                                    <p className="caf-card-text">Status Reason : {data.StatusReason}</p>
                                                                </div>
                                                            </div>
                                                            {meetingcounter !== "" && Number(meetingcounter) >= 1 && (
                                                                <>
                                                                    <div className="d-flex justify-content-center gap-2 p-2">
                                                                        <button type="button" className="btn qualify-btn text-light w-50"
                                                                            onClick={() => handleWonQoute(data.Quoteid)}
                                                                            disabled={proposalOptionType == "Both"}
                                                                        >
                                                                            Won
                                                                        </button>
                                                                        <button type="button" className="btn qualify-btn text-light w-50" onClick={() => handleLostQoute(data.Quoteid)}>
                                                                            Lost
                                                                        </button>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="col-12 text-center">
                                                    <p>No data available.</p>
                                                </div>
                                            )}
                                        </div>



                                    </div>
                                </fieldset>
                            </div>)}

                        {/* {(opportunityData?.ProductSegment == "Managed Wi-Fi Business-S" || opportunityData?.ProductSegment == "Managed Wi-Fi Business") &&
                            getPreSalesTask[0]?.MeetingDoneWithCustomer == "Yes" && (
                                <div
                                    className="Remarks-toggle mt-3"
                                    onClick={() => handleIconClick("SurveyDetails")}
                                >
                                    <span className="toggle-text">Survey Details</span>
                                    <span className=" float-end">
                                        <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                                    </span>
                                </div>
                                
                            )} */}

                        {activeForm === "SurveyDetails" && (
                            <div>
                                <div className="container shadow mb-3 bg-body rounded mt-4" id="form7" >
                                    {/* <BusinessOppotunitySurveyForm OppId={OppId} formInputData={formInputWifi} opportunitySurveyData={opportunityDataWifi}/> */}
                                    <fieldset className="contact-form p-1">
                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="Mobile Phone"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="SiteName"
                                                name="SiteName"
                                                value={opportunitySurveyData.SiteName || ""}
                                                onChange={formInputData}
                                            />
                                            <label htmlFor="mobilephone" className='mt-2'>Site Name*</label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="Mobile Phone"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="CustomerContactName"
                                                name="CustomerContactName"
                                                value={opportunitySurveyData.CustomerContactName || ""}
                                                onChange={formInputData}
                                            />
                                            <label htmlFor="mobilephone" className='mt-2'>Customer Contact Name*</label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="Mobile Phone"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="CustomerContactNumber"
                                                name="CustomerContactNumber"
                                                value={opportunitySurveyData?.CustomerContactNumber || ""}
                                                onChange={formInputData}
                                            />
                                            <label htmlFor="mobilephone" className='mt-2'>Customer Contact Number*</label>
                                        </div>
                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="Mobile Phone"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="Customeremailidsitespoc"
                                                name="Customeremailidsitespoc"
                                                value={opportunitySurveyData?.Customeremailidsitespoc || ""}
                                                onChange={formInputData}
                                            />
                                            <label htmlFor="mobilephone" className='mt-2'>Customer Email ID*</label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="Mobile Phone"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="ListofBuildings"
                                                name="ListofBuildings"
                                                value={opportunitySurveyData.ListofBuildings || ""}
                                                onChange={formInputData}
                                            />
                                            <label htmlFor="mobilephone" className='mt-2 upfont-textStyle'>List of Buildings/Blocks/Floors to be covered*</label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="Area to be Covered (in Sq. Ft)"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="AreaToBeCovered"
                                                name="AreatobeCovered"
                                                value={opportunitySurveyData.AreatobeCovered || ""}
                                                onChange={formInputData}
                                            />
                                            <label htmlFor="AreaToBeCovered" className="mt-2">Area to be Covered (in Sq. Ft)</label>
                                        </div>

                                        <div className="">
                                            <label className="select-search-label mt-1">
                                                Building and Floor Plan*
                                            </label>
                                            <Select
                                                className=" basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                id="BuildingFloorPlan"
                                                name="BuildingandFloorPlan"
                                                placeholder="Select Building and Floor Plan"
                                                styles={style}
                                                value={getBuildingAndFloorPlanOptions?.find((data) => data?.value == opportunitySurveyData?.BuildingandFloorPlan)}
                                                // value={selectedDropdownObj?.BuildingandFloorPlan} // Set the value based on your state
                                                onChange={(selectedOption) => formDropdownInput("BuildingandFloorPlan", selectedOption?.value)}
                                                options={getBuildingAndFloorPlanOptions}
                                            // isDisabled={disableFileds}
                                            />
                                        </div>

                                        <div className="">
                                            <label className="select-search-label mt-1">
                                                Network Security Required?
                                            </label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                id="NetworkSecurity"
                                                name="NetworkSecurityrequired"
                                                placeholder="Select Network Security"
                                                styles={style}
                                                value={getNetworkSecurityRequiredOptions?.find((data) => data.value == opportunitySurveyData?.NetworkSecurityrequired)}
                                                // value={selectedDropdownObj?.NetworkSecurity}
                                                onChange={(selectedOption) => formDropdownInput("NetworkSecurityrequired", selectedOption?.value)}
                                                options={getNetworkSecurityRequiredOptions}
                                            />
                                        </div>

                                        {(getNetworkSecurityRequiredOptions?.find((data) => data?.value == opportunitySurveyData?.NetworkSecurityrequired)?.label == "Firewall" ||
                                            getNetworkSecurityRequiredOptions?.find((data) => data?.value == opportunitySurveyData?.NetworkSecurityrequired)?.label == "UTM") &&
                                            (<div className="input-box form-floating">
                                                <input
                                                    type="text"
                                                    placeholder="Specific Security Features Required"
                                                    className="form-control input-text form-control-sm mt-1"
                                                    id="SecurityFeatures"
                                                    name="Anyspecificsecurity"
                                                    value={opportunitySurveyData.Anyspecificsecurity || ""}
                                                    onChange={formInputData}
                                                />
                                                <label htmlFor="SecurityFeatures" className="mt-2 upfont-textStyle">Any Specific Security Features Required?</label>
                                            </div>)}

                                        <div className="">
                                            <label className="select-search-label mt-1">
                                                Existing Network Security Device?
                                            </label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                id="ExistingNetworkSecurityDevice"
                                                name="ExistingNetworkSecurityDevice"
                                                placeholder="Select Existing Network Security Device"
                                                styles={style}
                                                value={getExistingNetworkSecurityDeviceOptions?.find((data) => data.value == opportunitySurveyData?.ExistingNetworkSecurityDevice)}
                                                // value={selectedDropdownObj?.ExistingNetworkSecurityDevice}
                                                onChange={(selectedOption) => formDropdownInput("ExistingNetworkSecurityDevice", selectedOption?.value)}
                                                options={getExistingNetworkSecurityDeviceOptions}
                                            />
                                        </div>




                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="Make/Model of Existing Security Device"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="MakeModelofexisting"
                                                name="MakeModelofexisting"
                                                value={opportunitySurveyData.MakeModelofexisting || ""}
                                                onChange={formInputData}
                                            />
                                            <label htmlFor="MakeModelofexisting" className="mt-2 upfont-textStyle">Make/Model of Existing Security Device</label>
                                        </div>

                                        <div className="">
                                            <label className="select-search-label mt-1">
                                                Bandwidth Required?
                                            </label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                id="BandwidthRequired"
                                                name="BandwidthRequired"
                                                placeholder="Select Bandwidth Required"
                                                styles={style}
                                                // value={selectedDropdownObj?.BandwidthRequired}
                                                value={getBandwidthRequiredOptions?.find((data) => data.value == opportunitySurveyData?.BandwidthRequired)}
                                                onChange={(selectedOption) => formDropdownInput("BandwidthRequired", selectedOption?.value)}
                                                options={getBandwidthRequiredOptions}
                                            />
                                        </div>


                                        {getBandwidthRequiredOptions?.find((data) => data.value == opportunitySurveyData?.BandwidthRequired)?.label == "Yes" &&
                                            (<div className="">
                                                <label className="select-search-label mt-1">
                                                    Bandwidth Type?
                                                </label>
                                                <Select
                                                    className="basic-single form-control form-control-sm p-1"
                                                    classNamePrefix="select"
                                                    id="BandwidthType"
                                                    name="BandwidthType"
                                                    placeholder="Select Bandwidth Type"
                                                    styles={style}
                                                    // value={selectedDropdownObj?.BandwidthRequired}
                                                    value={getBandwidthTypeOptions?.find((data) => data.value == opportunitySurveyData?.BandwidthType)}
                                                    onChange={(selectedOption) => formDropdownInput("BandwidthType", selectedOption?.value)}
                                                    options={getBandwidthTypeOptions}
                                                />
                                            </div>)}

                                        {(getBandwidthTypeOptions?.find((data) => data.value == opportunitySurveyData?.BandwidthType)?.label == "Site-Level: Dedicated Bandwidth" ||
                                            getBandwidthTypeOptions?.find((data) => data.value == opportunitySurveyData?.BandwidthType)?.label == "Site-Level: Broadband") && (
                                                <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        placeholder="Required Bandwidth (in Mbps)"
                                                        className="form-control input-text form-control-sm mt-1"
                                                        id="SiteName"
                                                        name="SiteName"
                                                        value={opportunitySurveyData.SiteName || ""}
                                                        onChange={formInputData}
                                                    />
                                                    <label htmlFor="mobilephone" className='mt-2'>Site Name*</label>
                                                </div>
                                            )}

                                        <div className="">
                                            <label className="select-search-label mt-1">
                                                Count of Existing Internet Links
                                            </label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                id="CountOfExistingInternetLinks"
                                                name="Countofexistinginternetlinks"
                                                placeholder="Select Count"
                                                styles={style}
                                                // value={selectedDropdownObj?.CountOfExistingInternetLinks}
                                                value={getCountOfExistingInternetLinksOptions?.find((data) => data.value == opportunitySurveyData?.Countofexistinginternetlinks)}
                                                onChange={(selectedOption) => formDropdownInput("Countofexistinginternetlinks", selectedOption?.value)}
                                                options={getCountOfExistingInternetLinksOptions}
                                            />
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="ISP of existing internet Link 1"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="ISPofexistinginternetLink1"
                                                name="ISPofexistinginternetLink1"
                                                value={opportunitySurveyData.ISPofexistinginternetLink1 || ""}
                                                onChange={formInputData}
                                            />
                                            <label htmlFor="ISPofexistinginternetLink1" className="mt-2">ISP of Existing Internet Link 1</label>
                                        </div>

                                        <div className="">
                                            <label className="select-search-label mt-1">
                                                Separate Network for Back-office Network?
                                            </label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                id="SeparateBackOfficeNetwork"
                                                name="SeparateBackOfficeNetwork"
                                                placeholder="Select Separate Network"
                                                styles={style}
                                                value={getSeparateNetworkForBackOfficeOptions?.find((data) => data.value == opportunitySurveyData?.SeparatenetworkBackoffice)}
                                                onChange={(selectedOption) => formDropdownInput("SeparatenetworkBackoffice", selectedOption?.value)}
                                                options={getSeparateNetworkForBackOfficeOptions}
                                            />
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="Mobile Phone"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="LinkTerminatingFloor"
                                                name="LinkTerminatingFloor"
                                                value={opportunitySurveyData.LinkTerminatingFloor || ""}
                                                onChange={formInputData}
                                            />
                                            <label htmlFor="mobilephone" className='mt-2'>Link Terminating Floor*</label>
                                        </div>


                                        <div className="">
                                            <label className="select-search-label mt-1">
                                                Wired LAN Integration?
                                            </label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                id="WiredLANIntegration"
                                                name="WiredLANIntegration"
                                                placeholder="Select Wired LAN Integration"
                                                styles={style}
                                                value={getWiredLANIntegrationOptions?.find((data) => data.value == opportunitySurveyData?.WiredLANIntegration)}
                                                onChange={(selectedOption) => formDropdownInput("WiredLANIntegration", selectedOption?.value)}
                                                options={getWiredLANIntegrationOptions}
                                            />
                                        </div>

                                        {/* {(getWiredLANIntegrationOptions?.find((data) => data.value == opportunitySurveyData?.WiredLANIntegration))?.label == "Yes" && (  */}
                                        <>
                                            <div className="input-box form-floating">
                                                <input
                                                    type="number"
                                                    placeholder="Tentative count of devices"
                                                    className="form-control input-text form-control-sm mt-1"
                                                    id="NoofwiredLANports"
                                                    name="NoofwiredLANports"
                                                    value={opportunitySurveyData.NoofwiredLANports}
                                                    onChange={formInputData}
                                                />
                                                <label htmlFor="TentativeDeviceCount" className="mt-2">No. of wired LAN ports</label>
                                            </div>

                                            <div className="">
                                                <label className="select-search-label mt-1">
                                                    Type of Wired LAN Setup
                                                </label>
                                                <Select
                                                    className="basic-single form-control form-control-sm p-1"
                                                    classNamePrefix="select"
                                                    id="TypeofWiredLANSetup"
                                                    name="TypeofWiredLANSetup"
                                                    placeholder="Select IoT Devices Connection"
                                                    styles={style}
                                                    value={getTypeOfWiredLANSetupOptions?.find((data) => data.value == opportunitySurveyData?.TypeofWiredLANSetup)}
                                                    onChange={(selectedOption) => formDropdownInput("TypeofWiredLANSetup", selectedOption.value)}
                                                    options={getTypeOfWiredLANSetupOptions}
                                                />
                                            </div>
                                        </>
                                        {/* )} */}

                                        <div className="">
                                            <label className="select-search-label mt-1">
                                                Existing Wi-Fi Cabling by Customer?
                                            </label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                id="ExistingWiFiCabling"
                                                name="ExistingWiFiCabling"
                                                placeholder="Select Existing Wi-Fi Cabling"
                                                styles={style}
                                                value={getExistingWiFiCablingByCustomerOptions?.find((data) => data.value == opportunitySurveyData?.ExistingWiFiCabling)}
                                                onChange={(selectedOption) => formDropdownInput("ExistingWiFiCabling", selectedOption?.value)}
                                                options={getExistingWiFiCablingByCustomerOptions}
                                            />
                                        </div>


                                        <div className="">
                                            <label className="select-search-label mt-1">
                                                API Integration Required?
                                            </label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                id="APIintegrationrequired"
                                                name="APIintegrationrequired"
                                                placeholder="Select API Integration"
                                                styles={style}
                                                value={getAPIIntegrationRequiredOptions?.find((data) => data.value == opportunitySurveyData?.APIintegrationrequired)}
                                                // value={selectedDropdownObj?.APIIntegrationRequired}
                                                onChange={(selectedOption) => formDropdownInput("APIintegrationrequired", selectedOption?.value)}
                                                options={getAPIIntegrationRequiredOptions}
                                            />
                                        </div>

                                        <div className="">
                                            <label className="select-search-label mt-1">
                                                PMS Vendor for API Integration?
                                            </label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                id="PMSVendorforAPIIntegration"
                                                name="PMSVendorforAPIIntegration"
                                                placeholder="Select PMS Vendor"
                                                styles={style}
                                                // value={selectedDropdownObj?.PMSVendorForAPIIntegration}
                                                value={getPMSVendorForAPIIntegrationOptions?.find((data) => data.value == opportunitySurveyData?.PMSVendorforAPIIntegration)}
                                                onChange={(selectedOption) => formDropdownInput("PMSVendorforAPIIntegration", selectedOption?.value)}
                                                options={getPMSVendorForAPIIntegrationOptions}
                                            />
                                        </div>

                                        <div className="">
                                            <label className="select-search-label mt-1">
                                                Any IoT Devices to be Connected?
                                            </label>
                                            <Select
                                                className="basic-single form-control form-control-sm p-1"
                                                classNamePrefix="select"
                                                id="AnyIOTdevicestobeconnected"
                                                name="AnyIOTdevicestobeconnected"
                                                placeholder="Select IoT Devices Connection"
                                                styles={style}
                                                value={getAnyIOTDevicesToBeConnectedOptions?.find((data) => data.value == opportunitySurveyData?.AnyIOTdevicestobeconnected)}
                                                onChange={(selectedOption) => formDropdownInput("AnyIOTdevicestobeconnected", selectedOption.value)}
                                                options={getAnyIOTDevicesToBeConnectedOptions}
                                            />
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="number"
                                                placeholder="Tentative count of devices"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="Tentativecountofdevices"
                                                name="Tentativecountofdevices"
                                                value={opportunitySurveyData.Tentativecountofdevices || ""}
                                                onChange={formInputData}
                                            />
                                            <label htmlFor="TentativeDeviceCount" className="mt-2">Tentative Count of Devices</label>
                                        </div>

                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="Special Request (if any)"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="SpecialRequest"
                                                name="SpecialRequest"
                                                value={opportunitySurveyData.SpecialRequest || ""}
                                                onChange={formInputData}
                                            />
                                            <label htmlFor="SpecialRequest" className="mt-2">Special Request (if any)</label>
                                        </div>

                                        <div className="mt-3 bg-body rounded mt-4 p-3" id="form7">
                                            {/* Table Header with Plus Icon on Right */}
                                            <div className="d-flex w-100 align-items-center mb-2">
                                                <h6 className="mb-0 text-nowrap flex-grow-1">User licence grid:</h6>
                                                <FaPlus
                                                    className="text-success"
                                                    type="button" data-bs-toggle="modal" data-bs-target="#exampleModal" data-bs-whatever="@mdo"
                                                    style={{ cursor: "pointer", fontSize: "1.0rem", marginRight: "5px" }}
                                                // onClick={addRow}
                                                />
                                            </div>

                                            {/* Bootstrap Table */}
                                            <div className="table-responsive small">
                                                <table className="table table-border table-sm table-striped small">
                                                    <thead className="table-secondary text-center small">
                                                        <tr>
                                                            <th>ID</th>
                                                            <th>User Type</th>
                                                            <th>No. of licences required </th>
                                                            <th>Speed Per User</th>
                                                            <th>Data Volume(in GB)</th>
                                                            <th>Plan Vilidity/Data Volume </th>
                                                            <th>Device per user</th>
                                                            <th>Login Machanism</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="text-center small">
                                                        {getUserlicencegridData?.length > 0 ? getUserlicencegridData.map((row, index) => (
                                                            <tr key={row.id} className="py-1">
                                                                <td>{index + 1}</td>
                                                                <td>{getUserTypeOptions.find((data) => data.value == row?.UserType).label}</td>
                                                                <td>{row.NoofUserLicensesrequired}</td>
                                                                <td>{getSpeedPerUserOptions.find((data) => data.value == row?.SpeedPerUser).label}</td>
                                                                <td>{row.DataVolumeinGB}</td>
                                                                <td>{row.DevicesperUser}</td>
                                                                <td>{getPlanValidityDataVolumeCriteriaOptions.find((data) => data.value == row?.PlanValidityDataVolumeCriteria).label}</td>
                                                                <td>{getLoginMechanismOptions.find((data) => data.value == row?.SpeedPerUser).label}</td>
                                                                <td>
                                                                    <FaEdit
                                                                        className="text-success mx-2"
                                                                        style={{ cursor: "pointer", fontSize: "0.9rem" }}
                                                                    // onClick={() => update(row.id)}
                                                                    />
                                                                    {/* <FaTrash
                                  className="text-danger"
                                  style={{ cursor: "pointer", fontSize: "0.9rem" }}
                                  // onClick={() => deleteRow(row.id)}
                                /> */}
                                                                </td>
                                                            </tr>
                                                        )) :
                                                            <tr>
                                                                <td colSpan="10" className="text-center text-muted">
                                                                    No data found
                                                                </td>
                                                            </tr>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        {/* ============ Model Grid Form ============= */}
                                        <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                            <div class="modal-dialog">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                        <h5 class="modal-title" id="exampleModalLabel">New User Licence Grid</h5>
                                                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                    </div>
                                                    <div class="modal-body">
                                                        <form>
                                                            <div class="mb-2">
                                                                <label for="recipient-name" class="col-form-label">User Type*</label>
                                                                <Select
                                                                    className="basic-single form-control form-control-sm p-1"
                                                                    classNamePrefix="select"
                                                                    placeholder="Select Option"
                                                                    name="dashboardReq"
                                                                    styles={style}
                                                                    value={userType}
                                                                    onChange={handleUserType}
                                                                    options={userTypeOption.map((data) => ({
                                                                        value: data.value,
                                                                        label: data.label,
                                                                    }))}
                                                                />
                                                            </div>
                                                            <div class="mb-2">
                                                                <label for="recipient-name" class="col-form-label">No. of User Licences Required*</label>
                                                                <input type="number"
                                                                    class="form-control"
                                                                    id="noUserLicences"
                                                                    name="noUserLicences"
                                                                    value={opportunityData.noUserLicences}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                            <div class="mb-2">
                                                                <label for="recipient-name" class="col-form-label">Speed Per User*</label>
                                                                <Select
                                                                    className="basic-single form-control form-control-sm p-1"
                                                                    classNamePrefix="select"
                                                                    placeholder="Select Option"
                                                                    name="dashboardReq"
                                                                    styles={style}
                                                                    value={speedPerUser}
                                                                    onChange={handleSpeedPerUser}
                                                                    options={speedPerUserOption.map((data) => ({
                                                                        value: data.value,
                                                                        label: data.label,
                                                                    }))}
                                                                />
                                                            </div>
                                                            <div class="mb-2">
                                                                <label for="recipient-name" class="col-form-label">Plan Validity/Data Volume Criteria*</label>
                                                                <Select
                                                                    className="basic-single form-control form-control-sm p-1"
                                                                    classNamePrefix="select"
                                                                    placeholder="Select Option"
                                                                    name="dashboardReq"
                                                                    styles={style}
                                                                    value={planValidity}
                                                                    onChange={handlePlanValidity}
                                                                    options={planValidityOption.map((data) => ({
                                                                        value: data.value,
                                                                        label: data.label,
                                                                    }))}
                                                                />
                                                            </div>

                                                            <div class="mb-2">
                                                                <label for="recipient-name" class="col-form-label">Data Valumn (in Gb)*</label>
                                                                <input type="number"
                                                                    class="form-control"
                                                                    id="dataValume"
                                                                    name="dataValume"
                                                                    value={opportunityData.dataValume}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>

                                                            <div class="mb-2">
                                                                <label for="recipient-name" class="col-form-label">Devices per User*</label>
                                                                <input type="number"
                                                                    class="form-control"
                                                                    id="devicesPerUser"
                                                                    name="devicesPerUser"
                                                                    value={opportunityData.devicesPerUser}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>

                                                            <div class="mb-2">
                                                                <label for="recipient-name" class="col-form-label">Login Mechanism*</label>
                                                                <Select
                                                                    className="basic-single form-control form-control-sm p-1"
                                                                    classNamePrefix="select"
                                                                    placeholder="Select Option"
                                                                    name="dashboardReq"
                                                                    styles={style}
                                                                    value={loginMechanism}
                                                                    onChange={handleLoginMechanism}
                                                                    options={loginMechanismOption.map((data) => ({
                                                                        value: data.value,
                                                                        label: data.label,
                                                                    }))}
                                                                />
                                                            </div>

                                                        </form>
                                                    </div>
                                                    <div class="modal-footer">
                                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                                        <button type="button" class="btn btn-primary" onClick={handleUserLicenceGrid}>Submit</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </fieldset>
                                </div>

                                {/* <div className="container shadow mb-3 bg-body rounded mt-4" id="form7" >
<fieldset className="contact-form p-2">
  </fieldset>
  </div> */}
                            </div>

                        )}


                        {/* {(opportunityData?.ProductSegment == "Managed Wi-Fi Business-S" || opportunityData?.ProductSegment == "Managed Wi-Fi Business") && (
                            <div
                                className="Remarks-toggle mt-3"
                                onClick={() => handleIconClick("SurveyTask")}
                            >
                                <span className="toggle-text">Survey Task</span>
                                <span className=" float-end">
                                    <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                                </span>
                            </div>
                        )} */}

                        {activeForm === "SurveyTask" && (
                            <div
                                className="container shadow mb-3 bg-body rounded mt-4"
                                id="form7"
                            >
                                <div className="input-box form-floating p-3 select-search-label">
                                    {getSurveyTaskData?.length > 0 && getSurveyTaskData[0]?.SurveyTaskID !== null ? getSurveyTaskData?.map((data, index) => (
                                        <div className="mt-2" key={index}>
                                            <strong>Survey Task ID: {data?.SurveyTaskID || "NA"}</strong>
                                            <div>Contact Person Name: {data?.CustomerName || "NA"}</div>
                                            <div>Created BY: {data?.CreatedBy || "NA"}</div>
                                            <div>Status: <span style={{ color: data?.Status === "Open" ? "red" : data?.Status === "Approved" ? "green" : "black" }}>{data?.Status || "NA"}</span></div>
                                        </div>
                                    )) : <div>No Survey Task Found.</div>}
                                </div>

                            </div>)}



                        <div
                            className="Remarks-toggle mt-3"
                            onClick={() => handleIconClick("form6")}
                        >
                            <span className="toggle-text">Feasibilty</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>


                        {activeForm === "form6" && (
                            <div
                                className="container shadow mb-3 bg-body rounded mt-4"
                                id="form6"
                            >
                                <div className="input-box form-floating p-3 select-search-label">
                                    {getFeasibilityData?.length > 0 ? getFeasibilityData?.map((data, index) => (
                                        <div className="input-box form-floating p-2" key={index}>
                                            <strong className=''>Feasibility Id: {data?.FeasibilityId || ""}</strong>
                                            <div>Route Type: {data?.RouteType ? "Redundant Route" : "Primary Route"}</div>
                                            <div>Owner: {data?.Owner || "NA"}</div>
                                            <div>Feasibilty Status: <span style={{ color: data?.FeasibilityStatus === "0" ? "red" : data?.FeasibilityStatus === "1" ? "green" : "black" }}> {data?.FeasibilityStatus == '1' ? 'Feasible' : '' || ""}</span></div>
                                            <div>ARC: {data?.Arc || "NA"}</div>
                                            <div>OTC: {data?.Otc || "NA"}</div>
                                            <div>ISP Name: {data?.IspName || "NA"}</div>
                                        </div>
                                    )) : <div>No Feasibility records found.</div>}
                                </div>
                            </div>)}


                        {/* <div
                            className="Remarks-toggle mt-3"
                            onClick={() => handleIconClick("form7")}
                        >
                            <span className="toggle-text">Pre-sales Task</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div> */}


                        {activeForm === "form7" && (
                            <div
                                className="container shadow mb-3 bg-body rounded mt-4"
                                id="form7"
                            >
                                <div className="input-box form-floating p-3 select-search-label">
                                    {getPreSalesTask?.length > 0 ? getPreSalesTask?.map((data, index) => (
                                        <div className="mt-2" key={index}>
                                            <strong>Pre-Sales Task Id: {data?.PresalesTaskID || "NA"}</strong>
                                            <div>Contact Person Name: {data?.ContactPersonName || "NA"}</div>
                                            <div>Meeting Done With Customer: {data?.MeetingDoneWithCustomer || "NA"}</div>
                                            <div>Created BY: {data?.CreatedBY || "NA"}</div>
                                            <div>Created On: {data?.CreatedOn || "NA"}</div>
                                            <div>Status: <span style={{ color: data?.Status === "Open" ? "red" : data?.Status === "Approved" ? "green" : "black" }}>{data?.Status || "NA"}</span></div>
                                        </div>
                                    )) : <div>No Pre-Sales Task Found.</div>}
                                </div>

                            </div>)}


                        {/* <div
                            className="Remarks-toggle mt-3"
                            onClick={() => handleIconClick("form8")}
                        >
                            <span className="toggle-text">DOA Approvals</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div> */}

                        {activeForm === "form8" && (
                            <div
                                className="container shadow mb-3 bg-body rounded mt-4"
                                id="form8"
                            >
                                <fieldset className="Remarks-form p-2">
                                    <div className="input-box form-floating">
                                        <div className="input-box form-floating p-3 select-search-label">
                                            {getDoaApprovalData?.length > 0 ? getDoaApprovalData?.map((data, index) => (
                                                <div className="input-box form-floating p-2" key={index}>
                                                    <strong>Name: {data?.Name || "NA"}</strong>
                                                    <div>Approval Requested Date: {data?.ApprovalRequestedDate || "NA"}</div>
                                                    <div>Approver: {data?.Approver || "NA"}</div>
                                                    <div>Status: {data?.Status || "NA"}</div>
                                                    <div>Status Reason: <span style={{ color: data?.StatusReason !== "Approved" ? "red" : data?.StatusReason == "Approved" ? "green" : "black" }}>{data?.StatusReason}</span></div>
                                                </div>
                                            )) : <div>No Approval records found.</div>}

                                        </div>
                                    </div>
                                </fieldset>
                            </div>)}


                        {/* <div
              className="Remarks-toggle mt-3"
              onClick={() => handleIconClick("form9")}
            >
              <span className="toggle-text">Quotes</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div> */}




                        {activeForm === "form9" && (
                            <div
                                className="container shadow mb-3 bg-body rounded mt-4"
                                id="form9"
                            >
                                <fieldset className="Remarks-form p-2">
                                    <div className="input-box form-floating">
                                        <div className="input-box form-floating p-3 select-search-label">
                                            {getQuoteDetail?.length > 0 ? getQuoteDetail?.map((data, index) => (
                                                <div className="input-box form-floating p-2" key={index}>
                                                    <strong>Quote ID: {data?.QuoteID || "NA"}</strong>
                                                    <div>Name: {data?.Name || "NA"}</div>
                                                    <div>Created On: {data?.CreatedOn || "NA"}</div>
                                                    <div>Status: {data?.Status}</div>
                                                </div>
                                            )) : <div>No Quote records found.</div>}

                                        </div>
                                    </div>
                                </fieldset>
                            </div>)}


                        {/* <div
              className="Remarks-toggle mt-3"
              onClick={() => handleIconClick("form10")}
            >
              <span className="toggle-text">Generate Quote</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div> */}




                        {activeForm === "form10" && (
                            <div
                                className="container shadow mb-3 bg-body rounded mt-4"
                                id="form10"
                            >
                                <fieldset className="Remarks-form p-2">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className=" form-control input-text form-control-sm"
                                            id="quote"
                                            name="quote"
                                            value={opportunityData.quote}
                                            onChange={handleChange}
                                            required
                                        />
                                        <label htmlFor="floatingInput">Quote</label>
                                    </div>
                                </fieldset>
                            </div>)}


                        {/* <div className="Remarks-toggle mt-3" onClick={() => handleIconClick("form11")}>
              <span className="toggle-text">Remarks</span>
              <span className=" float-end">
                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
              </span>
            </div> */}

                        {activeForm === "form11" && (
                            <div className="container shadow mb-3 bg-body rounded mt-4" id="form11">
                                <fieldset className="Remarks-form p-2">
                                    {/* <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="Remarks"
                                            name="Remarks"
                                            value={opportunityData.Remarks || ""} onChange={handleChange} />
                                        <label htmlFor="floatingInput" className="mt-2">Remarks</label>
                                    </div> */}
                                    <div className="remark-area">
                                            <label htmlFor="floatingInput">Remarks</label>
                                            <textarea
                                                type="text"
                                                placeholder=""
                                                className=" form-control input-text form-control-sm textarea"
                                                id="remark"
                                                name="remark"
                                                value={opportunityData.Remarks || ""} 
                                                onChange={handleChange}
                                            />
                                        </div>
                                </fieldset>
                            </div>)}

                        {/* <div
            className="doc-toggle mt-3"
            // hidden={docHide}
            onClick={manageDocClickBusiness}
          >
            <span className="toggle-text">Documents</span>
            <span className="float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div> */}


                        <div className=" text-center mt-5 mb-3">
                            <button
                                type="button"
                                className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                                onClick={handleUpdateOpportunity}
                                disabled={opportunityData.Status == "Won"}
                            >
                                Update
                            </button>
                        </div>

                    </div>
                </form>
            )}
        </>
    );
};

export default BusinessPgOpp;
